var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _path53, _path54, _g52, _path55, _path56, _path57, _g53, _path58, _path59, _path60, _g54, _path61, _path62, _g55, _path63, _g56, _path64, _path65, _path66, _g57, _path67, _path68, _path69, _g58, _path70, _path71, _path72, _g59, _path73, _path74, _path75, _g60, _path76, _path77, _g61, _path78, _path79, _g62, _path80, _g63, _path81, _g64, _path82, _g65, _path83, _g66, _path84, _g67, _path85, _g68, _path86, _g69, _path87, _g70, _path88, _g71, _path89, _g72, _path90, _g73, _path91, _g74, _path92, _g75, _path93, _g76, _path94, _g77, _path95, _g78, _path96, _g79, _path97, _g80, _path98, _g81, _path99, _g82, _path100, _g83, _path101, _g84, _path102, _g85, _path103, _g86, _path104, _g87, _path105, _g88, _path106, _g89, _path107, _g90, _path108, _g91, _path109, _g92, _path110, _g93, _path111, _g94, _path112, _g95, _path113, _g96, _path114, _g97, _path115, _g98, _path116, _g99, _path117, _g100, _path118, _g101, _path119, _g102, _path120, _g103, _path121, _g104, _path122, _g105, _path123, _g106, _path124, _g107, _path125, _g108, _path126, _g109, _path127, _g110, _path128, _g111, _path129, _g112, _path130, _g113, _path131, _g114, _path132, _g115, _path133, _g116, _path134, _path135, _path136, _g117, _path137, _g118, _path138, _path139, _g119, _path140, _path141, _g120, _path142, _path143, _g121, _path144, _path145, _g122, _path146, _path147, _g123, _path148, _path149, _g124, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNsf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 38,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03008 38.9794C4.59378 41.1488 2.37405 41.6823 0 41.6112C0 42.3106 0 43.1405 0 43.7214C2.64706 43.5673 5.38909 44.4683 6.59985 47.1831C6.84912 47.8232 7.07466 48.4753 7.28832 49.1273L7.2171 48.5108L8.40412 48.3804C8.45952 48.6649 8.53074 48.9495 8.61779 49.234C8.68901 49.4592 8.74836 49.6845 8.83145 49.9334C8.50839 48.6318 8.38828 47.2883 8.47535 45.9501L8.84332 45.4759C9.49619 44.7883 10.6832 45.0492 11.621 45.0492L12.2382 45.1914C9.99386 43.2524 7.939 41.1049 6.1013 38.7778L6.03008 38.9319",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2382 38.8252H0V49.9334H12.2382V38.8252Z",
    fill: "url(#paint0_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 49,
    width: 21,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 52.4941C12.364 52.7331 11.9988 52.8951 11.6111 52.9672C11.2235 53.0392 10.8243 53.0193 10.4458 52.9091C9.62073 52.0999 9.05475 51.0642 8.8196 49.9334L8.89083 50.3721L7.7038 50.704C7.57323 50.1705 7.41892 49.6489 7.25273 49.1273C7.41066 50.5282 7.47016 51.9385 7.43079 53.3477C6.93224 55.8965 5.05674 57.248 2.87262 58.0897L3.66792 60.0458C6.04197 58.8603 8.93831 58.6825 11.0987 60.7215C11.6091 61.255 12.1077 61.8003 12.5825 62.3694L12.2264 61.7411L13.2591 61.172C13.4253 61.4091 13.6033 61.6462 13.7932 61.8833L14.1019 62.2627C13.3439 61.2277 12.755 60.0793 12.3569 58.8603L12.4994 58.2912C12.903 57.3784 14.0544 57.1057 14.9446 56.8686C17.35 56.3719 19.8005 56.1256 22.2567 56.1336C21.9481 55.6594 21.6513 55.1734 21.3783 54.6755C19.478 54.802 17.5693 54.7025 15.6925 54.3791C14.8141 53.5729 16.1435 52.8498 16.3691 52.0911C17.0813 51.2968 17.7223 50.4906 18.4464 49.8149L17.2593 49.0443C15.8454 50.3375 14.3201 51.5038 12.7012 52.5297",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2567 49.0088H2.87262V62.3339H22.2567V49.0088Z",
    fill: "url(#paint1_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 48,
    width: 2,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2171 48.5109L7.28832 49.1274C7.45451 49.649 7.60882 50.1706 7.73939 50.7041L8.92642 50.3721L8.85519 49.9335C8.7721 49.6845 8.71275 49.4593 8.64153 49.2341C8.57031 49.0088 8.48722 48.665 8.42787 48.3805L7.2171 48.5109Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8908 48.3805H7.2171V50.7041H8.8908V48.3805Z",
    fill: "url(#paint2_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 48,
    width: 2,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2171 48.5109L7.28832 49.1274C7.45451 49.649 7.60882 50.1706 7.73939 50.7041L8.92642 50.3721L8.85519 49.9335C8.7721 49.6845 8.71275 49.4593 8.64153 49.2341C8.57031 49.0088 8.48722 48.665 8.42787 48.3805L7.2171 48.5109Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8908 48.3805H7.2171V50.7041H8.8908V48.3805Z",
    fill: "url(#paint3_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 56,
    width: 19,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7906 63.2941C18.292 63.9106 17.746 64.5745 16.9032 64.4796C15.7639 63.998 14.7902 63.1945 14.1018 62.1679L14.4342 62.6895L13.5083 63.4482C13.2155 63.0452 12.9069 62.65 12.5825 62.2627C13.2149 63.4955 13.7699 64.7665 14.2443 66.0682C14.7666 68.617 13.5796 70.5613 11.8702 72.1854C12.3569 72.6833 12.9504 73.2761 13.3659 73.6791C15.1227 71.6993 17.6985 70.4071 20.488 71.4622C21.1053 71.7468 21.675 72.0313 22.316 72.3395L21.77 71.9127L22.5178 70.988C22.7552 71.1421 23.0045 71.2963 23.2775 71.4385L23.8829 71.7705C22.7714 71.098 21.7738 70.2537 20.9272 69.2691L20.856 68.6882C20.856 67.6923 21.8412 67.0522 22.5534 66.4357C24.6012 65.0554 26.7848 63.8875 29.0702 62.9503C28.5954 62.6263 28.1325 62.2943 27.6814 61.9545C25.9677 62.8003 24.1583 63.4371 22.2923 63.8513C21.1765 63.4482 22.1261 62.2746 22.043 61.4803C22.4132 60.214 22.898 58.9839 23.4912 57.8052C23.147 57.3547 22.8146 56.9042 22.4941 56.4419C21.5396 58.8662 20.2961 61.1669 18.7906 63.2941Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0583 56.4419H11.8702V73.6791H29.0583V56.4419Z",
    fill: "url(#paint4_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 61,
    width: 3,
    height: 3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2263 61.7055L12.5824 62.3338C12.899 62.7132 13.2076 63.1083 13.5083 63.5193L14.4342 62.7606L14.1018 62.239L13.7932 61.8596C13.6033 61.6225 13.4252 61.3854 13.259 61.1483L12.2263 61.7055Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4461 61.1365H12.2263V63.5075H14.4461V61.1365Z",
    fill: "url(#paint5_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 61,
    width: 3,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2263 61.7055L12.5824 62.3338C12.899 62.7132 13.2076 63.1083 13.5083 63.5193L14.4342 62.7606L14.1018 62.239L13.7932 61.8596C13.6033 61.6225 13.4252 61.3854 13.259 61.1483L12.2263 61.7055Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4461 61.1365H12.2263V63.5075H14.4461V61.1365Z",
    fill: "url(#paint6_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 63,
    width: 16,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4886 70.8695C28.263 71.6282 28.0019 72.4581 27.2066 72.7426C26.0387 72.7487 24.8949 72.4106 23.9185 71.7705L24.3933 72.1024L23.7405 73.1457C23.2538 72.8612 22.7671 72.6004 22.2686 72.3395C23.3335 73.2141 24.3406 74.1566 25.2836 75.161C26.7436 77.3187 26.3875 79.5711 25.4142 81.7287L27.3609 82.5467C28.2393 80.0335 30.1266 77.864 33.0942 77.8047C33.8539 77.8047 34.6136 77.8047 35.3733 77.9233L34.6017 77.7099L34.946 76.5244C35.2318 76.5861 35.5212 76.6296 35.8125 76.6548H36.1805C34.9369 76.4554 33.7341 76.055 32.6194 75.4693L32.3226 74.9595C31.9547 74.0348 32.6075 73.0627 33.0349 72.2328C34.4084 70.1604 36.0002 68.2408 37.7829 66.5069C37.225 66.3883 36.6671 66.2579 36.1211 66.1038C34.8562 67.5507 33.4214 68.8404 31.8478 69.9448C30.6608 69.9448 31.0881 68.5459 30.6608 67.8465C30.559 66.5716 30.5709 65.2901 30.6964 64.0173C30.1979 63.7328 29.7112 63.4364 29.2483 63.1282C29.3041 65.7296 29.0491 68.3284 28.4886 70.8695Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8304 63.0688H22.316V82.5467H37.8304V63.0688Z",
    fill: "url(#paint7_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 70,
    width: 4,
    height: 4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 71.9127L22.316 72.3395C22.8146 72.6003 23.3013 72.8611 23.788 73.1457L24.3577 72.1024L23.8829 71.7705L23.2775 71.4385C23.0045 71.2963 22.7552 71.1422 22.5178 70.988L21.77 71.9127Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3577 70.988H21.77V73.1457H24.3577V70.988Z",
    fill: "url(#paint8_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 70,
    width: 4,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 71.9127L22.316 72.3395C22.8146 72.6003 23.3013 72.8611 23.788 73.1457L24.3577 72.1024L23.8829 71.7705L23.2775 71.4385C23.0045 71.2963 22.7552 71.1422 22.5178 70.988L21.77 71.9127Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3577 70.988H21.77V73.1457H24.3577V70.988Z",
    fill: "url(#paint9_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 66,
    width: 15,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7716 66.898C45.1634 68.7266 44.3343 70.4742 43.3026 72.1024C42.2105 72.6003 42.1156 71.0947 41.439 70.5968C40.7946 69.4243 40.2621 68.1938 39.8484 66.9217C39.2944 66.8585 38.7365 66.7755 38.1747 66.6728C39.2253 69.0747 39.9826 71.5943 40.43 74.177C40.5348 74.5567 40.5475 74.9558 40.467 75.3414C40.3865 75.7269 40.2151 76.0877 39.9671 76.3939C38.7783 76.8611 37.479 76.9723 36.228 76.714L36.9639 76.8918L36.8333 78.0773L35.4208 77.9114C36.6991 78.3084 37.9518 78.7835 39.1718 79.334C41.3678 80.7566 41.9019 82.9853 41.8307 85.3563H43.9199C43.7655 82.7008 44.6677 79.9741 47.386 78.7531C48.1061 78.4844 48.8302 78.2354 49.5582 78.0062L48.6561 78.1129L48.5374 76.9274C48.8104 76.9274 49.1072 76.797 49.392 76.714L49.6413 76.6429C48.4754 76.9166 47.2729 77.0007 46.0802 76.8918L45.6173 76.5362C44.917 75.8249 45.1544 74.6749 45.2375 73.7384C45.6981 71.2964 46.4224 68.9114 47.3978 66.6254C46.8281 66.7439 46.2108 66.8388 45.6885 66.9099",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6651 66.6135H35.4208V85.3445H49.6651V66.6135Z",
    fill: "url(#paint10_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 76,
    width: 3,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6492 77.6862L35.4208 77.8995L36.8334 78.0655L36.9639 76.88L36.228 76.7022H35.86C35.5687 76.677 35.2793 76.6335 34.9935 76.5718L34.6492 77.6862Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9639 76.5481H34.6492V78.0655H36.9639V76.5481Z",
    fill: "url(#paint11_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 76,
    width: 3,
    height: 3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6492 77.6862L35.4208 77.8995L36.8334 78.0655L36.9639 76.88L36.228 76.7022H35.86C35.5687 76.677 35.2793 76.6335 34.9935 76.5718L34.6492 77.6862Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9639 76.5481H34.6492V78.0655H36.9639V76.5481Z",
    fill: "url(#paint12_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 63,
    width: 16,
    height: 20
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8168 63.8749C54.9592 65.7999 54.8635 67.735 54.5319 69.6365C53.7247 70.5138 53.0006 69.186 52.2409 68.9607C51.1886 68.1264 50.2223 67.1891 49.3564 66.163C48.8104 66.3171 48.2644 66.4593 47.7065 66.5779C49.5987 68.3977 51.2682 70.4352 52.6801 72.6477C52.9193 72.9607 53.0816 73.3255 53.1537 73.7126C53.2259 74.0997 53.206 74.4984 53.0956 74.8764C52.1484 75.7859 50.9563 76.3998 49.6651 76.6428L50.6028 76.4769L50.9352 77.6624C50.4841 77.7809 50.033 77.9113 49.582 78.0536C50.888 77.9338 52.2002 77.8942 53.511 77.935C56.0631 78.4329 57.4045 80.306 58.2591 82.4874L60.2058 81.6931C59.0188 79.3221 58.8408 76.4294 60.8943 74.2718C61.4403 73.7502 61.9982 73.2523 62.5799 72.7662L61.7608 73.2167L61.1911 72.1735C61.4285 72.0194 61.6659 71.8415 61.9033 71.6518L62.1288 71.474C61.182 72.1474 60.1371 72.6712 59.0307 73.027L58.4609 72.8729C57.5469 72.4698 57.2739 71.3318 57.0365 70.4308C56.5268 67.9903 56.28 65.5024 56.3005 63.0095C55.8257 63.3296 55.339 63.626 54.8286 63.9224",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.568 62.9622H47.7065V82.44H62.568V62.9622Z",
    fill: "url(#paint13_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 76,
    width: 3,
    height: 3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.665 76.6428L49.4158 76.714C49.1309 76.7969 48.8341 76.8681 48.5611 76.9274L48.6798 78.1129L49.5819 78.0062C50.033 77.8639 50.4841 77.7335 50.9351 77.6149L50.6028 76.4294L49.665 76.5954",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.947 76.4768H48.5611V78.1128H50.947V76.4768Z",
    fill: "url(#paint14_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 76,
    width: 3,
    height: 3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.665 76.6428L49.4158 76.714C49.1309 76.7969 48.8341 76.8681 48.5611 76.9274L48.6798 78.1129L49.5819 78.0062C50.033 77.8639 50.4841 77.7335 50.9351 77.6149L50.6028 76.4294L49.665 76.5954",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.947 76.4768H48.5611V78.1128H50.947V76.4768Z",
    fill: "url(#paint15_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 56,
    width: 18,
    height: 18
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9626 57.6747C62.8301 59.403 63.4839 61.2302 63.9093 63.1162C63.6363 63.8631 63.0191 63.6852 62.4018 63.5074C62.1206 63.4051 61.8226 63.3569 61.5234 63.3652C60.2306 62.9922 58.978 62.4918 57.7843 61.8714C57.3332 62.2271 56.8703 62.559 56.4073 62.8791C58.8655 63.8372 61.1974 65.0912 63.3514 66.6134C63.9568 67.1114 64.6215 67.6567 64.5385 68.4984C64.0153 69.6917 63.1579 70.7086 62.0694 71.4266L62.9004 70.8931L63.6482 71.8178C63.2565 72.1142 62.8885 72.4106 62.5205 72.7188C63.6755 72.1203 64.8645 71.5898 66.0816 71.1302C68.6337 70.6086 70.5923 71.7941 72.2066 73.5012L73.7141 72.0075C71.7199 70.2529 70.4261 67.6804 71.4944 64.8945C71.8386 64.1239 72.2066 63.3652 72.6102 62.6183C72.3847 62.8791 72.171 63.1518 71.9574 63.4244L71.0433 62.6776L71.4351 62.0255C70.8494 62.9211 70.1286 63.7208 69.2984 64.3965L68.7168 64.4677C67.7078 64.4677 67.0668 63.4837 66.4614 62.7724C65.0413 60.7175 63.8473 58.5155 62.9004 56.2047C62.5799 56.6789 62.2356 57.1413 61.8795 57.5918",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7498 56.2877H56.4073V73.525H73.7498V56.2877Z",
    fill: "url(#paint16_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 70,
    width: 3,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1169 71.4267L61.8914 71.6045C61.654 71.7942 61.4166 71.972 61.1792 72.1261L61.749 73.1694L62.568 72.7189C62.936 72.4106 63.304 72.1143 63.6957 71.8179L62.9123 70.8932L62.0813 71.4267",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6957 70.8932H61.1792V73.1812H63.6957V70.8932Z",
    fill: "url(#paint17_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 70,
    width: 3,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1169 71.4267L61.8914 71.6045C61.654 71.7942 61.4166 71.972 61.1792 72.1261L61.749 73.1694L62.568 72.7189C62.936 72.4106 63.304 72.1143 63.6957 71.8179L62.9123 70.8932L62.0813 71.4267",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6957 70.8932H61.1792V73.1812H63.6957V70.8932Z",
    fill: "url(#paint18_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 48,
    width: 20,
    height: 15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0074 49.7201C68.1671 50.7993 69.2168 51.9906 70.1412 53.2766C70.1412 54.4621 68.7286 54.0472 68.0283 54.4621C66.7236 54.6063 65.4083 54.6301 64.0992 54.5333C63.8262 55.0312 63.5295 55.5172 63.2208 55.9796C65.8388 55.936 68.4526 56.2026 71.0077 56.7739C71.7674 56.9991 72.5864 57.2599 72.8832 58.0423C73.0613 59.299 72.171 60.8401 71.5775 61.9427V62.0493C71.8149 61.7056 72.0404 61.3736 72.2778 61.0535L73.3224 61.6226C73.1206 61.9545 72.9307 62.2983 72.7526 62.6421C73.5661 61.6729 74.4382 60.7544 75.3641 59.8917C77.5126 58.4336 79.7798 58.7774 81.9402 59.7613C82.2132 59.1212 82.5337 58.3506 82.7474 57.8052C80.2427 56.9398 77.9993 55.0549 77.9993 52.0911C77.9993 51.2494 78.0705 50.4196 78.1536 49.5897C78.0349 49.9572 77.9162 50.3366 77.8212 50.7752L76.6342 50.4433L76.741 49.8031C76.5592 50.7734 76.2268 51.7093 75.7558 52.5772L75.2454 52.8735C74.3195 53.2411 73.3461 52.589 72.5152 52.1622C71.0908 51.119 69.6426 50.135 68.325 48.9969C67.9214 49.2578 67.506 49.5304 67.138 49.7794",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6405 48.9376H63.1733V62.6421H82.6405V48.9376Z",
    fill: "url(#paint19_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 61,
    width: 3,
    height: 3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4706 62.0493L71.0789 62.7013L71.9929 63.4482C72.2066 63.1755 72.4203 62.9029 72.6458 62.642C72.8713 62.3812 73.0138 61.9544 73.2156 61.6225L72.171 61.0535C71.9336 61.3736 71.708 61.7055 71.4706 62.0493Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2156 61.0535H71.0789V63.4482H73.2156V61.0535Z",
    fill: "url(#paint20_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 61,
    width: 3,
    height: 3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4706 62.0493L71.0789 62.7013L71.9929 63.4482C72.2066 63.1755 72.4203 62.9029 72.6458 62.642C72.8713 62.3812 73.0138 61.9544 73.2156 61.6225L72.171 61.0535C71.9336 61.3736 71.708 61.7055 71.4706 62.0493Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2156 61.0535H71.0789V63.4482H73.2156V61.0535Z",
    fill: "url(#paint21_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 38,
    width: 13,
    height: 12
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2749 45.1203L74.1652 44.9543C74.547 44.8466 74.9491 44.8324 75.3376 44.9129C75.726 44.9934 76.0894 45.1662 76.3968 45.4166C77.0378 46.4954 76.8122 48.2618 76.6817 49.5185C76.6758 49.5935 76.6758 49.6688 76.6817 49.7437C76.7885 49.2458 76.8835 48.7479 77.0022 48.2737L78.1892 48.3923C78.1892 48.7953 78.0823 49.1865 78.0467 49.5778C78.4149 48.44 78.8469 47.3239 79.3406 46.2346C80.765 44.0652 82.9966 43.5317 85.3588 43.6028C85.3588 42.9034 85.3588 42.0735 85.3588 41.4926C84.1992 41.6392 83.0214 41.4762 81.9454 41.0201C80.8695 40.564 79.9338 39.8312 79.2338 38.8964C77.4536 41.1655 75.4668 43.2649 73.2986 45.1677",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3707 38.849H73.2749V49.7438H85.3707V38.849Z",
    fill: "url(#paint22_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 48,
    width: 3,
    height: 3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.658 49.7911L76.5511 50.4313L77.7382 50.7632C77.8331 50.3839 77.9518 50.0045 78.0705 49.5777C78.1892 49.151 78.1536 48.7834 78.213 48.3922L77.026 48.2737C76.9073 48.7479 76.8123 49.2458 76.7055 49.7437",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1655 48.2737H76.5511V50.7277H78.1655V48.2737Z",
    fill: "url(#paint23_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 48,
    width: 3,
    height: 3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.658 49.7911L76.5511 50.4313L77.7382 50.7632C77.8331 50.3839 77.9518 50.0045 78.0705 49.5777C78.1892 49.151 78.1536 48.7834 78.213 48.3922L77.026 48.2737C76.9073 48.7479 76.8123 49.2458 76.7055 49.7437",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1655 48.2737H76.5511V50.7277H78.1655V48.2737Z",
    fill: "url(#paint24_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 50,
    width: 47,
    height: 18
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4909 50.3958C19.9742 51.8688 20.6025 53.2905 21.3664 54.6399H21.6988L21.5919 54.4502H21.6632C21.7103 54.6449 21.7738 54.8352 21.8531 55.0192C22.0092 55.4075 22.2211 55.7709 22.4822 56.098H22.2448C22.3279 56.2047 22.3991 56.3233 22.4822 56.4418C22.4822 56.3707 22.5416 56.2996 22.5653 56.2403C22.5462 56.1869 22.5223 56.1353 22.4941 56.0862H22.5653C22.777 56.7011 23.1308 57.2575 23.598 57.7103L23.503 57.8644C24.7324 59.4065 26.1388 60.7991 27.6932 62.0137L27.9663 61.8714L27.7882 61.6462H27.8713C27.9853 61.8136 28.1166 61.9685 28.263 62.1085C28.5384 62.3809 28.8453 62.6197 29.177 62.8198V62.7487C29.6068 63.2378 30.1483 63.616 30.7558 63.8512C30.7558 63.8512 30.7558 63.9342 30.7558 63.9816C32.4814 64.9517 34.319 65.7081 36.2279 66.2341L36.406 66.0207L36.1923 65.9496H36.2754C36.4456 66.0584 36.6242 66.1536 36.8096 66.2341C37.1902 66.3877 37.5892 66.4913 37.9966 66.5423L37.866 66.6609L38.2103 66.7201L38.139 66.5542C38.139 66.5542 39.8721 66.8387 39.8484 66.8387V66.9691C40.7901 67.0783 41.7373 67.1337 42.6853 67.1351C43.7171 67.138 44.748 67.0746 45.7716 66.9454C45.7716 66.8624 45.7716 66.7794 45.8547 66.7083C46.4195 66.6884 46.9825 66.633 47.5403 66.5423C47.5381 66.5818 47.5381 66.6214 47.5403 66.6609H47.7658L47.6471 66.5423H47.4809V66.3882C48.1309 66.4218 48.7802 66.3084 49.3801 66.0563L49.4632 66.1511C51.3697 65.6129 53.2033 64.8446 54.9235 63.8631C54.9298 63.7842 54.9298 63.7049 54.9235 63.626L54.7218 63.7208V63.6497C54.9167 63.6026 55.1073 63.5392 55.2915 63.46C55.6812 63.306 56.0453 63.0942 56.3717 62.8317C56.3717 62.8317 56.3717 62.9147 56.3717 62.9502L56.4904 62.8673H56.3598C56.3054 62.8838 56.2534 62.9077 56.2055 62.9384V62.8554C56.818 62.6503 57.3718 62.3006 57.8199 61.8359H57.9148C59.475 60.6137 60.8783 59.2042 62.0932 57.6392C62.0623 57.5658 62.0267 57.4945 61.9863 57.4258L61.8439 57.5918V57.5088C62.0068 57.3889 62.1615 57.2582 62.3068 57.1176C62.6024 56.8229 62.8542 56.4876 63.0547 56.1217C63.0498 56.1651 63.0498 56.2088 63.0547 56.2521L63.2446 55.9439H63.0547L62.936 56.0743H62.8766C63.3301 55.6427 63.6827 55.1164 63.9093 54.5332V54.5924H64.0992C64.8378 53.2739 65.4499 51.8886 65.9273 50.455C65.5118 50.6921 65.0963 50.9292 64.669 51.1545C62.972 55.598 59.9635 59.4219 56.042 62.1198C52.1205 64.8177 47.471 66.2623 42.7091 66.2623C37.9472 66.2623 33.2976 64.8177 29.3761 62.1198C25.4546 59.4219 22.4462 55.598 20.7491 51.1545L19.4909 50.3958Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8798 50.3958H19.4909V67.0877H65.8798V50.3958Z",
    fill: "url(#paint25_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 62,
    width: 1,
    height: 2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0702 62.9502L29.2482 63.0688C29.2482 63.0095 29.2482 62.9621 29.2482 62.9028L29.0821 62.9621",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2482 62.891H29.0702V63.0688H29.2482V62.891Z",
    fill: "url(#paint26_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 54,
    width: 2,
    height: 3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7107 54.6162H21.3783C21.6513 55.1141 21.9481 55.6002 22.2567 56.0744H22.5534C22.2923 55.7472 22.0804 55.3838 21.9243 54.9956C21.8451 54.8116 21.7816 54.6212 21.7344 54.4265H21.6632L21.7107 54.6162Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 54.4265H21.3783V56.1099H22.4941V54.4265Z",
    fill: "url(#paint27_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 54,
    width: 2,
    height: 3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7107 54.6162H21.3783C21.6513 55.1141 21.9481 55.6002 22.2567 56.0744H22.5534C22.2923 55.7472 22.0804 55.3838 21.9243 54.9956C21.8451 54.8116 21.7816 54.6212 21.7344 54.4265H21.6632L21.7107 54.6162Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 54.4265H21.3783V56.1099H22.4941V54.4265Z",
    fill: "url(#paint28_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 61,
    width: 3,
    height: 2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9544 61.8122L27.6814 61.9545C28.1325 62.2943 28.5954 62.6263 29.0702 62.9503L29.2364 62.8911H29.177C28.8453 62.6909 28.5385 62.4521 28.263 62.1798C28.1166 62.0398 27.9853 61.8848 27.8713 61.7174H27.7882L27.9544 61.8122Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2364 61.67H27.6814V62.9504H29.2364V61.67Z",
    fill: "url(#paint29_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 61,
    width: 3,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9544 61.8122L27.6814 61.9545C28.1325 62.2943 28.5954 62.6263 29.0702 62.9503L29.2364 62.8911H29.177C28.8453 62.6909 28.5385 62.4521 28.263 62.1798C28.1166 62.0398 27.9853 61.8848 27.8713 61.7174H27.7882L27.9544 61.8122Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2364 61.67H27.6814V62.9504H29.2364V61.67Z",
    fill: "url(#paint30_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 56,
    width: 2,
    height: 2
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5534 56.0862C22.5817 56.1354 22.6055 56.187 22.6247 56.2404C22.6247 56.2996 22.5653 56.3708 22.5416 56.4419C22.8621 56.9042 23.1944 57.3547 23.5387 57.8052L23.6336 57.6511C23.1507 57.2068 22.7805 56.6541 22.5534 56.0388V56.0862Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6218 56.0388H22.4941V57.7934H23.6218V56.0388Z",
    fill: "url(#paint31_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 56,
    width: 2,
    height: 2
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5534 56.0862C22.5817 56.1354 22.6055 56.187 22.6247 56.2404C22.6247 56.2996 22.5653 56.3708 22.5416 56.4419C22.8621 56.9042 23.1944 57.3547 23.5387 57.8052L23.6336 57.6511C23.1507 57.2068 22.7805 56.6541 22.5534 56.0388V56.0862Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6218 56.0388H22.4941V57.7934H23.6218V56.0388Z",
    fill: "url(#paint32_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 65,
    width: 2,
    height: 2
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.133 65.9259L36.3467 65.9971L36.1686 66.2105C36.7146 66.3646 37.2725 66.495 37.8304 66.6135L37.961 66.495C37.5537 66.4439 37.1547 66.3403 36.774 66.1867C36.5887 66.1062 36.41 66.0111 36.2398 65.9022H36.1567",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9491 65.9022H36.133V66.6017H37.9491V65.9022Z",
    fill: "url(#paint33_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 65,
    width: 2,
    height: 2
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.133 65.9259L36.3467 65.9971L36.1686 66.2105C36.7146 66.3646 37.2725 66.495 37.8304 66.6135L37.961 66.495C37.5537 66.4439 37.1547 66.3403 36.774 66.1867C36.5887 66.1062 36.41 66.0111 36.2398 65.9022H36.1567",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9491 65.9022H36.133V66.6017H37.9491V65.9022Z",
    fill: "url(#paint34_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 62,
    width: 2,
    height: 2
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1177 62.8318H29.2008C29.2008 62.8318 29.2008 62.9385 29.2008 62.9977C29.6637 63.306 30.1504 63.6023 30.6489 63.8869C30.6489 63.8869 30.6489 63.792 30.6489 63.7565C30.0415 63.5212 29.4999 63.143 29.0702 62.6539L29.1177 62.8318Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7558 62.7251H29.1177V63.958H30.7558V62.7251Z",
    fill: "url(#paint35_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 62,
    width: 2,
    height: 2
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1177 62.8318H29.2008C29.2008 62.8318 29.2008 62.9385 29.2008 62.9977C29.6637 63.306 30.1504 63.6023 30.6489 63.8869C30.6489 63.8869 30.6489 63.792 30.6489 63.7565C30.0415 63.5212 29.4999 63.143 29.0702 62.6539L29.1177 62.8318Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7676 62.7251H29.1177V63.958H30.7676V62.7251Z",
    fill: "url(#paint36_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 66,
    width: 3,
    height: 1
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8547 66.661C45.8547 66.7321 45.8547 66.8151 45.7716 66.8981C46.3532 66.8269 46.9586 66.7321 47.4809 66.6135C47.4788 66.5741 47.4788 66.5345 47.4809 66.495C46.9231 66.5856 46.3601 66.6411 45.7953 66.661",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5284 66.495H45.7716V66.8981H47.5284V66.495Z",
    fill: "url(#paint37_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 66,
    width: 3,
    height: 1
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8547 66.661C45.8547 66.7321 45.8547 66.8151 45.7716 66.8981C46.3532 66.8269 46.9586 66.7321 47.4809 66.6135C47.4788 66.5741 47.4788 66.5345 47.4809 66.495C46.9231 66.5856 46.3601 66.6411 45.7953 66.661",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5284 66.495H45.7716V66.8981H47.5284V66.495Z",
    fill: "url(#paint38_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 66,
    width: 2,
    height: 1
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1035 66.5068L38.1747 66.6728C38.7365 66.7756 39.2944 66.8585 39.8484 66.9218V66.7914C39.8484 66.7914 38.2459 66.5068 38.1509 66.5068",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8484 66.5068H38.1035V66.9218H39.8484V66.5068Z",
    fill: "url(#paint39_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 66,
    width: 2,
    height: 1
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1035 66.5068L38.1747 66.6728C38.7365 66.7756 39.2944 66.8585 39.8484 66.9218V66.7914C39.8484 66.7914 38.2459 66.5068 38.1509 66.5068",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8484 66.5068H38.1035V66.9218H39.8484V66.5068Z",
    fill: "url(#paint40_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 62,
    width: 3,
    height: 2
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2203 63.4719C55.036 63.5511 54.8454 63.6145 54.6505 63.6616V63.7328L54.8523 63.6379C54.8585 63.7168 54.8585 63.7961 54.8523 63.875C55.3627 63.5786 55.8494 63.2823 56.3242 62.9622C56.3242 62.9622 56.3242 62.8792 56.3242 62.8436C55.9978 63.1061 55.6337 63.318 55.244 63.4719",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2886 62.8436H54.603V63.8632H56.2886V62.8436Z",
    fill: "url(#paint41_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 62,
    width: 3,
    height: 2
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2203 63.4719C55.036 63.5511 54.8454 63.6145 54.6505 63.6616V63.7328L54.8523 63.6379C54.8585 63.7168 54.8585 63.7961 54.8523 63.875C55.3627 63.5786 55.8494 63.2823 56.3242 62.9622C56.3242 62.9622 56.3242 62.8792 56.3242 62.8436C55.9978 63.1061 55.6337 63.318 55.244 63.4719",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2886 62.8436H54.603V63.875H56.2886V62.8436Z",
    fill: "url(#paint42_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 66,
    width: 3,
    height: 1
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3208 66.0444C48.7208 66.2965 48.0716 66.41 47.4216 66.3764V66.4594H47.5878L47.7065 66.5779C48.2644 66.4594 48.8104 66.3171 49.3564 66.163L49.2733 66.0681",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3447 66.0444H47.4099V66.5661H49.3447V66.0444Z",
    fill: "url(#paint43_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 66,
    width: 3,
    height: 1
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3208 66.0444C48.7208 66.2965 48.0716 66.41 47.4216 66.3764V66.4594H47.5878L47.7065 66.5779C48.2644 66.4594 48.8104 66.3171 49.3564 66.163L49.2733 66.0681",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3447 66.0444H47.4099V66.5661H49.3447V66.0444Z",
    fill: "url(#paint44_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 56,
    width: 2,
    height: 2
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1882 57.1532C62.0428 57.2938 61.8881 57.4245 61.7252 57.5444V57.6274L61.8677 57.4614C61.908 57.5301 61.9437 57.6014 61.9745 57.6748C62.3306 57.2243 62.6748 56.762 62.9953 56.2878C62.9904 56.2444 62.9904 56.2007 62.9953 56.1573C62.7949 56.5232 62.543 56.8585 62.2475 57.1532",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9836 56.1573H61.7135V57.6748H62.9836V56.1573Z",
    fill: "url(#paint45_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 56,
    width: 2,
    height: 2
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1882 57.1532C62.0428 57.2938 61.8881 57.4245 61.7252 57.5444V57.6274L61.8677 57.4614C61.908 57.5301 61.9437 57.6014 61.9745 57.6748C62.3306 57.2243 62.6748 56.762 62.9953 56.2878C62.9904 56.2444 62.9904 56.2007 62.9953 56.1573C62.7949 56.5232 62.543 56.8585 62.2475 57.1532",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9836 56.1573H61.7135V57.6748H62.9836V56.1573Z",
    fill: "url(#paint46_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 61,
    width: 2,
    height: 2
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.713 61.7885C57.265 62.2531 56.7111 62.6029 56.0987 62.808V62.891C56.1466 62.8603 56.1985 62.8363 56.253 62.8198H56.3836C56.8465 62.4998 57.3095 62.1678 57.7605 61.8122H57.6656L57.713 61.7885Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7844 61.7885H56.087V62.9028H57.7844V61.7885Z",
    fill: "url(#paint47_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 61,
    width: 2,
    height: 2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M57.713 61.7885C57.265 62.2531 56.7111 62.6029 56.0987 62.808V62.891C56.1466 62.8603 56.1985 62.8363 56.253 62.8198H56.3836C56.8465 62.4998 57.3095 62.1678 57.7605 61.8122H57.6656L57.713 61.7885Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7844 61.7885H56.087V62.9028H57.7844V61.7885Z",
    fill: "url(#paint48_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 54,
    width: 3,
    height: 3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9094 54.5332C63.6651 55.1317 63.2876 55.6669 62.8054 56.098H62.8648L62.9835 55.9676H63.1734C63.482 55.5053 63.7788 55.0192 64.0518 54.5213H63.8975V54.462",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0637 54.462H62.8054V56.098H64.0637V54.462Z",
    fill: "url(#paint49_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 54,
    width: 3,
    height: 3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9094 54.5332C63.6651 55.1317 63.2876 55.6669 62.8054 56.098H62.8648L62.9835 55.9676H63.1734C63.482 55.5053 63.7788 55.0192 64.0518 54.5213H63.8975V54.462",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0518 54.462H62.8054V56.098H64.0518V54.462Z",
    fill: "url(#paint50_radial_187_41690)"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1678 13.2658C23.9208 13.4262 23.683 13.6003 23.4556 13.7874L23.0876 14.0838C24.1342 13.3237 25.2911 12.728 26.5181 12.3174L27.0879 12.4715C28.0019 12.8746 28.2749 14.0127 28.5123 14.9136C29.0229 17.3379 29.2697 19.8102 29.2483 22.2875C29.7231 21.9674 30.2097 21.671 30.7083 21.3865C30.5816 19.4728 30.6812 17.5509 31.005 15.6605C31.8122 14.7832 32.5363 16.111 33.296 16.3362C34.3518 17.1708 35.322 18.108 36.1923 19.134C36.7384 18.9918 37.2963 18.8614 37.8542 18.7428C35.9505 16.9185 34.2727 14.8727 32.8568 12.6493C32.6176 12.3363 32.4553 11.9715 32.3832 11.5844C32.311 11.1973 32.3309 10.7986 32.4413 10.4206C33.2344 9.60762 34.2503 9.04672 35.3614 8.80829L34.9578 8.87942L34.6255 7.69391C35.1715 7.56351 35.7175 7.39754 36.2517 7.23157C34.8563 7.38142 33.4527 7.44082 32.0496 7.40939C29.4975 6.91148 28.1443 5.03838 27.3015 2.85706L25.3548 3.65134C26.5418 6.02235 26.708 8.91498 24.6663 11.0726C24.1203 11.5942 23.5624 12.0921 22.9808 12.5782L23.6099 12.2225L24.1678 13.2658Z",
    fill: "#DBBF85"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3393 22.406C14.1733 22.6493 14.0227 22.9027 13.8882 23.1647C13.7576 23.4018 13.6152 23.6508 13.4727 23.9234C14.1547 22.7953 15.0122 21.7829 16.013 20.9241L16.5946 20.8411C17.5917 20.8411 18.2446 21.8369 18.8499 22.5482C20.2679 24.6003 21.4617 26.7981 22.411 29.1041C22.7315 28.6299 23.0639 28.1675 23.42 27.717C22.5529 25.9939 21.903 24.1702 21.4851 22.2874C21.9006 21.1612 23.0757 22.1214 23.8592 22.0385C25.1505 22.4056 26.4029 22.898 27.5983 23.5085C28.0375 23.1647 28.4886 22.8209 28.9634 22.5127C26.5153 21.5538 24.1918 20.304 22.043 18.7902C21.4258 18.2923 20.761 17.7351 20.7967 16.8934C21.2929 15.7433 22.119 14.7657 23.1707 14.0837L22.6722 14.4038L21.9243 13.4791C22.3042 13.1946 22.684 12.8864 23.1114 12.5781C21.8504 13.2105 20.5499 13.7609 19.2179 14.226C16.6777 14.7476 14.7191 13.5621 13.0929 11.855L11.5972 13.3606C13.5796 15.127 14.8734 17.6995 13.817 20.4736C13.5558 21.0545 13.2828 21.6591 12.9979 22.1926C13.1404 22.0266 13.2709 21.8488 13.4134 21.671L14.3393 22.406Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 4,
    height: 3
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9689 12.5782C22.6009 12.8864 22.2211 13.1946 21.7819 13.4792L22.5297 14.4039L23.0282 14.0838L23.3962 13.7874C23.6236 13.6003 23.8614 13.4262 24.1084 13.2658L23.5387 12.2225L22.9095 12.5782",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1678 12.2225H21.8412V14.4039H24.1678V12.2225Z",
    fill: "url(#paint51_radial_187_41690)"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5534 14.4039L23.0519 14.0838L23.4199 13.7874C23.6473 13.6003 23.8851 13.4262 24.1321 13.2658L23.5624 12.2225L22.9332 12.5782C22.5653 12.8864 22.1854 13.1828 21.7462 13.4792L22.5534 14.4039Z",
    fill: "#DBBF85"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.244 32.305C11.1817 31.9375 12.1551 32.5895 12.986 33.0163C15.0707 34.3849 17.001 35.9749 18.7431 37.7583C18.8618 37.1893 18.9924 36.644 19.1467 36.0868C17.6872 34.8228 16.3877 33.3856 15.277 31.8071C15.277 30.6216 16.6777 31.0484 17.378 30.6216C18.7298 30.4663 20.0937 30.4464 21.4495 30.5623C21.7344 30.0644 22.0311 29.5783 22.3516 29.1041C19.6982 29.1695 17.0468 28.9067 14.4579 28.3217C13.6982 28.0846 12.8673 27.8357 12.5824 27.0414C12.5648 25.9297 12.8744 24.8374 13.4727 23.8998L13.1759 24.3266L12.1314 23.7457C12.44 23.2359 12.7249 22.7024 12.9979 22.1689C12.1182 23.2402 11.1706 24.2539 10.1609 25.2038C8.00052 26.662 5.74518 26.3064 3.58479 25.3342L2.76575 27.2666C5.28224 28.132 7.51384 30.017 7.51384 32.9926C7.51384 33.775 7.51384 34.5693 7.38327 35.3636C7.47823 35.0554 7.57319 34.7353 7.65628 34.4271L8.84331 34.759C8.78155 35.0444 8.73794 35.3335 8.71273 35.6244C8.70697 35.6598 8.70697 35.6958 8.71273 35.7311C8.89406 34.625 9.25491 33.5559 9.78105 32.5658L10.244 32.305Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 3,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0573 22.1926C12.7842 22.7261 12.4994 23.2596 12.1907 23.7694L13.2353 24.3503L13.5321 23.9235C13.6745 23.6508 13.817 23.4019 13.9475 23.1648C14.082 22.9028 14.2327 22.6494 14.3986 22.406L13.4727 21.671C13.3303 21.8488 13.1997 22.0267 13.0573 22.1926Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3393 21.671H12.1314V24.3503H14.3393V21.671Z",
    fill: "url(#paint52_radial_187_41690)"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13.176 24.3503L13.4727 23.9235C13.6152 23.6508 13.7576 23.4019 13.8882 23.1648C14.0188 22.9277 14.1731 22.655 14.3393 22.406L13.4134 21.671C13.2828 21.8488 13.1404 22.0267 12.9979 22.1926C12.7249 22.7261 12.44 23.2596 12.1314 23.7694L13.176 24.3503Z",
    fill: "#DBBF85"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2382 45.2388C14.4417 45.6693 16.594 46.3288 18.66 47.2068C18.5651 46.6496 18.4701 46.0924 18.4107 45.5234C16.6056 44.9181 14.8799 44.0982 13.2709 43.0812C12.7724 42.0024 14.2799 41.8364 14.7785 41.22C15.9457 40.5827 17.1697 40.0549 18.4345 39.6432C18.4938 39.0742 18.5888 38.517 18.6956 37.9598C16.2961 39.0129 13.7768 39.7693 11.1936 40.2123C10.8135 40.317 10.4138 40.3296 10.0278 40.2492C9.64177 40.1688 9.28049 39.9977 8.97391 39.7499C8.49379 38.4741 8.39078 37.0874 8.67716 35.7548C8.59407 36.1223 8.52285 36.4898 8.42788 36.8455L7.24086 36.7506C7.31208 36.312 7.35956 35.8733 7.40704 35.4229C7.03681 36.5924 6.60088 37.7402 6.10132 38.8608C7.93902 41.1879 9.99388 43.3354 12.2382 45.2744",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 34,
    width: 2,
    height: 3
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40703 35.3874C7.40703 35.826 7.31207 36.2765 7.24084 36.7151L8.42787 36.8455C8.52283 36.4899 8.59405 36.1224 8.67714 35.7549C8.67138 35.7195 8.67138 35.6835 8.67714 35.6482C8.70235 35.3572 8.74596 35.0682 8.80772 34.7827L7.62069 34.4508C7.5376 34.759 7.44264 35.0791 7.34768 35.3874",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80772 34.4508H7.24084V36.8455H8.80772V34.4508Z",
    fill: "url(#paint53_radial_187_41690)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81959 34.7827L7.63256 34.4508C7.54947 34.759 7.45451 35.0791 7.35955 35.3874C7.26459 35.6956 7.31207 36.2765 7.24084 36.7507L8.42787 36.8811C8.52283 36.5254 8.59405 36.1579 8.67714 35.7904V35.6837C8.70235 35.3928 8.74596 35.1037 8.80772 34.8183",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 47,
    width: 3,
    height: 3
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2356 49.0088L18.4226 49.7794C18.6521 49.5739 18.8776 49.3842 19.0992 49.2104C18.9568 48.665 18.8143 48.1197 18.7075 47.5625C18.2208 48.0604 17.7223 48.5465 17.2119 49.0088",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.123 47.5625H17.2356V49.7794H19.123V47.5625Z",
    fill: "url(#paint54_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 47,
    width: 3,
    height: 3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2834 49.0562L67.0075 49.72C67.4229 49.4711 67.8384 49.1984 68.1945 48.9376C67.6576 48.4632 67.1502 47.9564 66.6751 47.4202C66.5564 47.9892 66.4258 48.5464 66.2834 49.0917",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.242 47.3846H66.2834V49.7201H68.242V47.3846Z",
    fill: "url(#paint55_radial_187_41690)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0111 35.826C78.0111 36.1263 78.0468 36.4227 78.118 36.7151L76.931 36.8455C76.8766 36.557 76.8052 36.272 76.7173 35.9919C76.7173 35.8971 76.7173 35.8023 76.6342 35.6956C76.916 36.8587 77.0043 38.0603 76.8953 39.2521L76.5392 39.7144C75.827 40.4139 74.6756 40.1886 73.7379 40.1056C71.2948 39.6485 68.9073 38.9332 66.6157 37.9717C66.7226 38.5289 66.8175 39.1572 66.8887 39.667C68.7039 40.2712 70.438 41.0953 72.0523 42.121C72.5508 43.1998 71.0433 43.3065 70.5329 43.9822C69.3786 44.6176 68.1663 45.1416 66.9125 45.5471C66.8571 46.1161 66.774 46.6733 66.6632 47.2187C68.7732 46.3042 70.9733 45.6129 73.2274 45.1559C75.3956 43.2531 77.3824 41.1537 79.1626 38.8846C78.9769 38.6099 78.8141 38.3204 78.6759 38.0191C78.4029 37.3078 78.1536 36.5847 77.9281 35.8615",
    fill: "#DBBF85"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1354 24.125C71.9692 23.8879 71.7911 23.6508 71.6012 23.4137L71.1027 22.7972C71.9042 23.8813 72.5365 25.0804 72.9782 26.3538L72.8239 26.9109C72.4321 27.8356 71.2807 28.0964 70.3905 28.3454C67.965 28.8416 65.4949 29.0879 63.019 29.0804C63.3277 29.5546 63.6363 30.0407 63.9212 30.5267C65.8298 30.398 67.7471 30.5015 69.6308 30.835C70.5092 31.6411 69.1797 32.3524 68.9542 33.123C68.125 34.1533 67.2032 35.1057 66.2003 35.9682C66.3546 36.5017 66.4852 37.047 66.6039 37.6042C68.4185 35.7294 70.4508 34.0778 72.6577 32.6843C72.9674 32.4427 73.3301 32.278 73.716 32.2038C74.102 32.1296 74.5 32.148 74.8774 32.2576C75.7816 33.1924 76.3923 34.371 76.6342 35.6481C76.6342 35.3399 76.5274 35.0435 76.4799 34.7471L77.6669 34.4152C77.7856 34.8775 77.9162 35.328 78.0586 35.7785C77.9387 34.4742 77.8991 33.1637 77.9399 31.8545C78.4385 29.3057 80.314 27.9542 82.4981 27.1125C82.2369 26.4605 81.9283 25.6899 81.7028 25.1564C79.3287 26.3419 76.4324 26.5197 74.272 24.4807C73.8091 23.9946 73.358 23.4967 72.9307 22.9869L73.2156 23.4967L72.1354 24.125Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 34,
    width: 3,
    height: 3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4799 34.7946C76.4799 35.091 76.5749 35.3873 76.6342 35.6956C76.6342 35.8023 76.6342 35.8971 76.7173 35.9919C76.8052 36.272 76.8766 36.557 76.931 36.8455L78.118 36.7151C78.0705 36.4227 78.0349 36.1263 78.0112 35.826C77.8687 35.3755 77.7382 34.925 77.6195 34.4626L76.4799 34.7946Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.118 34.4626H76.4799V36.8455H78.118V34.4626Z",
    fill: "url(#paint56_radial_187_41690)"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4799 34.7945C76.4799 35.0908 76.5749 35.3872 76.6342 35.6955C76.6342 35.8021 76.6342 35.897 76.7173 35.9918C76.8052 36.2719 76.8766 36.5569 76.931 36.8454L78.118 36.715C78.0705 36.4226 78.0349 36.1262 78.0112 35.8259C77.8687 35.3754 77.7382 34.9249 77.6195 34.4625L76.4799 34.7945Z",
    fill: "#DBBF85"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9122 14.226C62.663 14.06 62.4137 13.9059 62.1526 13.7637L61.1673 13.242C62.3997 13.9779 63.5092 14.9019 64.4554 15.9805L64.5266 16.5614C64.5266 17.5573 63.5414 18.1974 62.8292 18.802C60.7588 20.227 58.5375 21.4197 56.2056 22.3586C56.6804 22.6668 57.1433 22.9987 57.5825 23.3425C59.3231 22.4707 61.1652 21.8177 63.0666 21.3983C64.1824 21.8014 63.2327 22.975 63.3158 23.7693C62.9403 25.0674 62.4394 26.326 61.8202 27.5274C62.1763 27.966 62.5087 28.4283 62.8292 28.8907C63.7859 26.4345 65.0417 24.1052 66.5683 21.9555C67.0668 21.339 67.6129 20.6751 68.4556 20.7107C69.5089 21.1351 70.4162 21.8558 71.0671 22.7853L70.889 22.5245L71.8268 21.7777C72.1592 22.2282 72.5153 22.6668 72.8832 23.1054C72.2124 21.8616 71.6255 20.5745 71.1264 19.2525C70.6042 16.7037 71.7912 14.7595 73.5005 13.1353C73.0138 12.6374 72.4203 12.0447 72.0048 11.6416C70.2481 13.6214 67.6722 14.9136 64.8827 13.8585C64.3485 13.6214 63.8263 13.3724 63.304 13.1116L63.6482 13.3724L62.9122 14.226Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 21,
    width: 4,
    height: 4
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M70.889 22.5246L71.1027 22.8565L71.6013 23.473C71.7912 23.7101 71.9692 23.9472 72.1354 24.1843L73.1681 23.6152L72.8832 23.1055C72.5153 22.6668 72.1591 22.2282 71.8268 21.7777L70.889 22.5246Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1681 21.7184H70.889V24.125H73.1681V21.7184Z",
    fill: "url(#paint57_radial_187_41690)"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M70.889 22.5246L71.1026 22.8565L71.6012 23.473C71.7911 23.7101 71.9692 23.9472 72.1354 24.1843L73.1681 23.6152L72.8832 23.1055C72.5152 22.6668 72.1591 22.2282 71.8267 21.7777L70.889 22.5246Z",
    fill: "#DBBF85"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5672 8.80831H50.4841C51.2666 8.99174 52.0211 9.2788 52.7275 9.66187L53.0243 10.1716C53.3923 11.1082 52.7394 12.0684 52.3121 12.9102C50.9183 15.02 49.2983 16.9719 47.4809 18.731C47.809 18.7691 48.1316 18.8447 48.4424 18.9562C48.6917 18.9562 48.9291 19.0748 49.1665 19.1341C50.4547 17.6361 51.9262 16.3059 53.5466 15.1745C54.7336 15.1745 54.2944 16.5734 54.7336 17.2728C54.8814 18.644 54.8814 20.0271 54.7336 21.3984C55.1912 21.5801 55.6131 21.8409 55.98 22.1689L56.253 22.3468C56.1609 19.6597 56.4041 16.9716 56.9771 14.3446C57.2026 13.5859 57.4638 12.7679 58.2472 12.4715C59.2755 12.4474 60.2891 12.719 61.1673 13.254L61.0248 13.1473L61.5946 12.104C62.1644 12.4478 62.7816 12.756 63.3158 13.0406C62.173 12.1232 61.098 11.1248 60.099 10.0531C58.6508 7.90732 58.995 5.65487 59.9802 3.55652L58.0335 2.73853C57.1551 5.23994 55.2678 7.48054 52.3002 7.48054C51.3862 7.48054 50.4841 7.40941 49.5819 7.31457C50.0093 7.45683 50.4603 7.58724 50.8995 7.70579L50.5672 8.80831Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 12,
    width: 3,
    height: 3
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0367 13.1591L61.1792 13.254L62.1644 13.7756C62.4216 13.9122 62.6713 14.0626 62.9122 14.2261L63.6601 13.3014L63.3277 13.0406C62.7461 12.7442 62.1407 12.436 61.6065 12.0922L61.0367 13.1591Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6719 12.104H61.0367V14.2261H63.6719V12.104Z",
    fill: "url(#paint58_radial_187_41690)"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0367 13.1591L61.1792 13.254L62.1644 13.7756C62.4256 13.9178 62.6748 14.072 62.9241 14.2379L63.6719 13.3132L63.3277 13.0406C62.7461 12.7442 62.1407 12.436 61.6065 12.0922L61.0367 13.1591Z",
    fill: "#DBBF85"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9758 8.36966L36.1211 8.58305L35.3615 8.8083C36.6755 8.47805 38.0343 8.36195 39.3855 8.4645L39.8484 8.82015C40.5487 9.53146 40.3232 10.6814 40.2401 11.6179C39.7833 14.0595 39.0629 16.4444 38.0916 18.731C38.6495 18.6243 39.2193 18.5413 39.789 18.4702C40.4003 16.6503 41.2293 14.9109 42.2581 13.2895C43.3382 12.7916 43.4451 14.2972 44.1098 14.7951C44.7628 15.9732 45.2994 17.212 45.7123 18.4939C46.2821 18.565 46.8993 18.648 47.3979 18.7547C46.3269 16.3326 45.5575 13.7885 45.1069 11.1793C45.0005 10.8006 44.9859 10.4019 45.0643 10.0164C45.1428 9.63095 45.312 9.26964 45.558 8.96241C46.65 8.31039 48.4187 8.54749 49.6651 8.67789C49.9381 8.67789 50.1992 8.74902 50.4604 8.78459C49.7719 8.61862 49.0834 8.48821 48.4424 8.3341L48.573 7.14859L49.5582 7.279C48.4652 6.91522 47.3915 6.49579 46.3414 6.02236C44.1929 4.5879 43.6469 2.37101 43.73 0H41.6171C41.7714 2.64367 40.8574 5.38219 38.151 6.5914C37.5218 6.84036 36.8927 7.05375 36.2517 7.26714L36.8571 7.18416L36.9758 8.36966Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 7,
    width: 3,
    height: 2
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2517 7.26715C35.7176 7.43312 35.1715 7.59909 34.6255 7.72949L34.9579 8.915L35.3614 8.84387L36.1211 8.61862L36.9758 8.40523L36.8571 7.21973L36.2517 7.30271",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9877 7.1842H34.6255V8.87948H36.9877V7.1842Z",
    fill: "url(#paint59_radial_187_41690)"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9579 8.87948L35.3614 8.80835L36.1211 8.5831C36.406 8.50011 36.6909 8.42898 36.9877 8.36971L36.8571 7.1842L36.2517 7.26719C35.7176 7.43316 35.1715 7.59913 34.6255 7.72954L34.9579 8.87948Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 7,
    width: 3,
    height: 2
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M48.478 8.29854L50.4841 8.74903H50.5672L50.8996 7.56353C50.4604 7.44498 50.0093 7.31457 49.582 7.17231L48.5967 7.11304L48.478 8.29854Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9114 7.14856H48.478V8.79641H50.9114V7.14856Z",
    fill: "url(#paint60_radial_187_41690)"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.478 8.29854C49.1071 8.45266 49.7956 8.58306 50.4841 8.74903H50.5672L50.8996 7.56353C50.4604 7.44498 50.0093 7.31457 49.582 7.17231L48.5967 7.11304L48.478 8.29854Z",
    fill: "#DBBF85"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 1,
    height: 1
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.66 47.2068L18.7313 47.5624L18.8737 47.4202V47.3253L18.66 47.2068Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8737 47.2068H18.66V47.5624H18.8737V47.2068Z",
    fill: "url(#paint61_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 28,
    width: 1,
    height: 2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8173 29.0211V29.116H62.9834L62.9122 28.9026C62.9142 28.9421 62.9142 28.9816 62.9122 29.0211",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0191 28.9026H62.8173V29.116H63.0191V28.9026Z",
    fill: "url(#paint62_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 18,
    width: 2,
    height: 1
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8542 18.7429L37.9491 18.8377H37.9848L38.056 18.6954H37.8067",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1035 18.6954H37.8542V18.8377H38.1035V18.6954Z",
    fill: "url(#paint63_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 50,
    height: 34
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M39.789 18.4346C39.789 18.5294 39.7296 18.6124 39.694 18.6954H39.9196H39.8602C39.6586 18.6832 39.4564 18.6832 39.2548 18.6954C38.8539 18.6907 38.4543 18.7426 38.0678 18.8495V18.9681C37.4178 18.9344 36.7685 19.0479 36.1686 19.3L36.0974 19.2052C34.1824 19.7299 32.3402 20.4905 30.6133 21.4695C30.6133 21.5525 30.6133 21.6473 30.6133 21.7421L30.8032 21.6354C30.8032 21.6354 30.8032 21.6354 30.8032 21.7066C30.6083 21.7537 30.4177 21.8171 30.2335 21.8963C29.8438 22.0502 29.4796 22.2621 29.1533 22.5246C29.1587 22.4694 29.1587 22.4138 29.1533 22.3586L28.8209 22.5838L28.9752 22.6431L29.1177 22.572V22.6431C28.501 22.8525 27.9434 23.2061 27.4914 23.6745L27.3846 23.6152C25.8242 24.8416 24.4209 26.2551 23.2063 27.8238L23.3131 28.049L23.4674 27.883C23.4619 27.9064 23.4619 27.9308 23.4674 27.9542C23.3131 28.0846 23.1588 28.2031 23.0045 28.3573C22.7687 28.5842 22.5614 28.839 22.3872 29.116H22.4585C21.9688 29.5452 21.5901 30.0861 21.3545 30.6927H21.2952C20.3036 32.4162 19.5301 34.2559 18.9923 36.1697L19.1823 36.3357L19.2535 36.1223C19.2483 36.1457 19.2483 36.17 19.2535 36.1934C19.1445 36.3675 19.0492 36.5499 18.9686 36.7388C18.81 37.1173 18.706 37.5165 18.66 37.9243L18.565 37.8176C18.565 37.8887 18.565 37.9717 18.565 38.0428C18.6233 38.0264 18.6791 38.0025 18.7312 37.9717C18.7408 37.9208 18.7408 37.8685 18.7312 37.8176H18.8143C18.5316 38.4011 18.3893 39.0425 18.3988 39.6907C18.4044 39.6713 18.4044 39.6508 18.3988 39.6314H18.2564C18.1859 40.6456 18.1819 41.6634 18.2445 42.6781C18.2459 43.6289 18.3014 44.5789 18.4107 45.5234C18.5117 45.5642 18.6147 45.5998 18.7193 45.6301V45.4167C18.7066 45.618 18.7066 45.8199 18.7193 46.0213C18.7171 46.4216 18.769 46.8203 18.8736 47.2068H18.9923C18.9486 47.8516 19.0584 48.4975 19.3128 49.0917C19.2626 49.1234 19.215 49.1591 19.1704 49.1984C19.2891 49.5896 19.4078 49.9927 19.5384 50.3839L20.7966 51.0715C19.4456 47.5198 18.9785 43.6935 19.4354 39.9216C19.8924 36.1498 21.2597 32.5451 23.4199 29.4177C25.5801 26.2903 28.4685 23.7336 31.8367 21.9674C35.205 20.2013 38.9523 19.2785 42.7566 19.2785C46.5608 19.2785 50.3081 20.2013 53.6764 21.9674C57.0446 23.7336 59.933 26.2903 62.0932 29.4177C64.2534 32.5451 65.6207 36.1498 66.0777 39.9216C66.5346 43.6935 66.0675 47.5198 64.7165 51.0715C65.1438 50.8463 65.5593 50.6092 65.9747 50.3721C66.1172 49.9334 66.2477 49.4829 66.3783 49.0324L66.1765 48.8665L66.1053 49.068C66.1053 49.068 66.1053 49.068 66.1053 48.9969C66.2104 48.8266 66.3017 48.6482 66.3783 48.4634C66.5406 48.0853 66.6485 47.6862 66.6988 47.2779L66.7938 47.3846V47.1831L66.5801 47.2779C66.534 47.3165 66.4975 47.3652 66.4733 47.4202H66.3783C66.6694 46.8392 66.816 46.1967 66.8056 45.5471H66.9837C67.0868 44.5943 67.1343 43.6364 67.1261 42.6781C67.129 41.6595 67.0656 40.6418 66.9362 39.6314L66.6395 39.5366V39.7499V39.6907C66.6576 39.4895 66.6576 39.2872 66.6395 39.0861C66.6335 38.6847 66.5736 38.286 66.4614 37.9006L66.6395 37.9835C66.6452 37.8888 66.6452 37.7938 66.6395 37.699L66.497 37.8531C66.4861 37.8798 66.4781 37.9077 66.4733 37.9361H66.3902C66.4298 37.2904 66.3159 36.6445 66.0578 36.0512L66.1884 35.9445C65.6557 34.0477 64.8902 32.224 63.9093 30.5149H63.6244L63.7194 30.7164H63.6482C63.6482 30.5267 63.5413 30.337 63.4701 30.1355C63.3153 29.7786 63.1201 29.4405 62.8885 29.1278H62.8172C62.6023 28.5179 62.2489 27.9661 61.7845 27.5155C61.7879 27.492 61.7879 27.468 61.7845 27.4444C60.5485 25.8818 59.1253 24.4764 57.5469 23.2596L57.3688 23.3544L57.535 23.4967H57.4519C57.3346 23.3355 57.2036 23.1847 57.0602 23.0462C56.8096 22.7938 56.5308 22.5711 56.2293 22.3823C56.1913 22.3483 56.1592 22.3082 56.1343 22.2638C56.0731 22.1908 56.0056 22.1234 55.9325 22.0622C53.8438 20.7068 51.5574 19.683 49.1546 19.0273L49.0834 19.1103L49.2852 19.1814H49.214C49.0409 19.0811 48.8626 18.9901 48.6798 18.9088L48.4424 18.9681C48.0982 18.8732 47.7539 18.8021 47.3978 18.731C47.4007 18.7704 47.4007 18.81 47.3978 18.8495C47.4529 18.8576 47.5089 18.8576 47.564 18.8495V18.9325C46.9793 18.6514 46.3374 18.5094 45.6885 18.5176C45.6938 18.4862 45.6938 18.4541 45.6885 18.4227C44.7075 18.3088 43.7203 18.2573 42.7328 18.2686C41.765 18.2697 40.798 18.3251 39.8365 18.4346",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1261 18.2686H18.2445V51.0952H67.1261V18.2686Z",
    fill: "url(#paint64_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 21,
    width: 2,
    height: 2
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2482 22.2874C29.2537 22.3426 29.2537 22.3982 29.2482 22.4534C29.5746 22.1909 29.9388 21.9791 30.3284 21.8251C30.5127 21.746 30.7033 21.6825 30.8982 21.6354C30.8982 21.6354 30.8982 21.6354 30.8982 21.5643L30.7083 21.671C30.7083 21.5761 30.7083 21.4813 30.7083 21.3983C30.2097 21.6749 29.723 21.9713 29.2482 22.2874Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9221 21.3983H29.2365V22.4534H30.9221V21.3983Z",
    fill: "url(#paint65_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 21,
    width: 2,
    height: 2
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2482 22.2874C29.2537 22.3426 29.2537 22.3982 29.2482 22.4534C29.5746 22.1909 29.9388 21.9791 30.3284 21.8251C30.5127 21.746 30.7033 21.6825 30.8982 21.6354C30.8982 21.6354 30.8982 21.6354 30.8982 21.5643L30.7083 21.671C30.7083 21.5761 30.7083 21.4813 30.7083 21.3983C30.2097 21.6749 29.723 21.9713 29.2482 22.2874Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9221 21.3983H29.2365V22.4534H30.9221V21.3983Z",
    fill: "url(#paint66_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 18,
    width: 3,
    height: 2
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1923 19.134L36.2635 19.2289C36.8635 18.9768 37.5127 18.8633 38.1628 18.8969V18.8258H38.0678H37.9847L37.8898 18.731C37.3319 18.8495 36.774 18.9799 36.2279 19.1222",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1272 18.7428H36.1923V19.2526H38.1272V18.7428Z",
    fill: "url(#paint67_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 18,
    width: 3,
    height: 2
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1923 19.134L36.2635 19.2289C36.8635 18.9768 37.5127 18.8633 38.1628 18.8969V18.8258H38.0678H37.9847L37.8898 18.731C37.3319 18.8495 36.774 18.9799 36.2279 19.1222",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1272 18.7428H36.1923V19.2526H38.1272V18.7428Z",
    fill: "url(#paint68_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 27,
    width: 2,
    height: 3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3635 29.1041C22.4054 29.0707 22.4415 29.0307 22.4703 28.9856C22.6445 28.7086 22.8518 28.4538 23.0876 28.2268C23.2419 28.0727 23.3962 27.9542 23.5505 27.8238C23.545 27.8004 23.545 27.776 23.5505 27.7526L23.3962 27.9186L23.2894 27.6934C22.9333 28.1439 22.6009 28.6062 22.2804 29.0804",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6336 27.717H22.3635V29.1278H23.6336V27.717Z",
    fill: "url(#paint69_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 27,
    width: 2,
    height: 3
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3635 29.1041C22.4054 29.0707 22.4415 29.0307 22.4703 28.9856C22.6445 28.7086 22.8518 28.4538 23.0876 28.2268C23.2419 28.0727 23.3962 27.9542 23.5505 27.8238C23.545 27.8004 23.545 27.776 23.5505 27.7526L23.3962 27.9186L23.2894 27.6934C22.9333 28.1439 22.6009 28.6062 22.2804 29.0804",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6336 27.717H22.3635V29.1278H23.6336V27.717Z",
    fill: "url(#paint70_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 22,
    width: 3,
    height: 2
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0702 22.5246H28.9159C28.4411 22.8329 27.99 23.1766 27.5508 23.5204L27.6576 23.5797C28.1002 23.1059 28.6496 22.7442 29.2601 22.5246V22.4535L29.1177 22.5246",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2601 22.5009H27.5508V23.6152H29.2601V22.5009Z",
    fill: "url(#paint71_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 22,
    width: 3,
    height: 2
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0702 22.5246H28.9159C28.4411 22.8329 27.99 23.1766 27.5508 23.5204L27.6576 23.5797C28.1002 23.1059 28.6496 22.7442 29.2601 22.5246V22.4535L29.1177 22.5246",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2601 22.5009H27.5508V23.6152H29.2601V22.5009Z",
    fill: "url(#paint72_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 36,
    width: 2,
    height: 2
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3366 36.229L19.1467 36.063C18.9924 36.6202 18.8618 37.1655 18.7431 37.7346L18.8381 37.8413C18.8841 37.4335 18.988 37.0343 19.1467 36.6558C19.2273 36.4669 19.3226 36.2845 19.4316 36.1104C19.4264 36.087 19.4264 36.0627 19.4316 36.0393L19.3366 36.229Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 36.0156H18.7431V37.8294H19.4316V36.0156Z",
    fill: "url(#paint73_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 36,
    width: 2,
    height: 2
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3366 36.229L19.1467 36.063C18.9924 36.6202 18.8618 37.1655 18.7431 37.7346L18.8381 37.8413C18.8841 37.4335 18.988 37.0343 19.1467 36.6558C19.2273 36.4669 19.3226 36.2845 19.4316 36.1104C19.4264 36.087 19.4264 36.0627 19.4316 36.0393L19.3366 36.229Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 36.0156H18.7431V37.8294H19.4316V36.0156Z",
    fill: "url(#paint74_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 2,
    height: 2
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M22.411 29.2345V29.1278C22.0905 29.602 21.7937 30.0881 21.5089 30.586H21.5682C21.8038 29.9794 22.1825 29.4385 22.6721 29.0093H22.6009L22.4703 29.2345",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6128 29.0093H21.4495V30.6453H22.6128V29.0093Z",
    fill: "url(#paint75_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 2,
    height: 2
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M22.411 29.2345V29.1278C22.0905 29.602 21.7937 30.0881 21.5089 30.586H21.5682C21.8038 29.9794 22.1825 29.4385 22.6721 29.0093H22.6009L22.4703 29.2345",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6128 29.0093H21.4495V30.6453H22.6128V29.0093Z",
    fill: "url(#paint76_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 29,
    width: 1,
    height: 1
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4348 29.1278V29.2345L22.5653 29.0093C22.5365 29.0544 22.5004 29.0945 22.4585 29.1278",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5535 29.0093H22.3754V29.2464H22.5535V29.0093Z",
    fill: "url(#paint77_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 29,
    width: 1,
    height: 1
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4348 29.1278V29.2345L22.5653 29.0093C22.5365 29.0544 22.5004 29.0945 22.4585 29.1278",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5535 29.0093H22.3754V29.2464H22.5535V29.0093Z",
    fill: "url(#paint78_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 29,
    width: 1,
    height: 1
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4348 29.1278V29.2345L22.5653 29.0093C22.5365 29.0544 22.5004 29.0945 22.4585 29.1278",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5535 29.0093H22.3754V29.2464H22.5535V29.0093Z",
    fill: "url(#paint79_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 37,
    width: 1,
    height: 3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 37.9361C18.8097 37.9669 18.7538 37.9908 18.6956 38.0073C18.5888 38.5644 18.4938 39.1216 18.4344 39.6907H18.5769C18.5825 39.71 18.5825 39.7306 18.5769 39.7499C18.5482 39.062 18.691 38.3776 18.9923 37.7583H18.9093C18.9189 37.8092 18.9189 37.8615 18.9093 37.9124",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0161 37.7346H18.4344V39.6551H19.0161V37.7346Z",
    fill: "url(#paint80_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 37,
    width: 1,
    height: 3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 37.9361C18.8097 37.9669 18.7538 37.9908 18.6956 38.0073C18.5888 38.5644 18.4938 39.1216 18.4344 39.6907H18.5769C18.5825 39.71 18.5825 39.7306 18.5769 39.7499C18.5482 39.062 18.691 38.3776 18.9923 37.7583H18.9093C18.9189 37.8092 18.9189 37.8615 18.9093 37.9124",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0161 37.7346H18.4344V39.6551H19.0161V37.7346Z",
    fill: "url(#paint81_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 45,
    width: 1,
    height: 3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7193 45.6301C18.6147 45.5999 18.5117 45.5642 18.4107 45.5234C18.4701 46.0924 18.5531 46.7089 18.66 47.2068L18.8736 47.3135C18.8792 47.2901 18.8792 47.2658 18.8736 47.2424C18.769 46.856 18.7171 46.4572 18.7193 46.0569C18.7066 45.8555 18.7066 45.6536 18.7193 45.4523V45.6301Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8736 45.4167H18.4107V47.3136H18.8736V45.4167Z",
    fill: "url(#paint82_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 45,
    width: 1,
    height: 3
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7193 45.6301C18.6147 45.5999 18.5117 45.5642 18.4107 45.5234C18.4701 46.0924 18.5531 46.7089 18.66 47.2068L18.8736 47.3135C18.8792 47.2901 18.8792 47.2658 18.8736 47.2424C18.769 46.856 18.7171 46.4572 18.7193 46.0569C18.7066 45.8555 18.7066 45.6536 18.7193 45.4523V45.6301Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8736 45.4167H18.4107V47.3136H18.8736V45.4167Z",
    fill: "url(#paint83_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 2,
    height: 3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 47.2423C18.8618 47.2423 18.8618 47.2423 18.8618 47.3134V47.4201L18.7194 47.5743C18.8262 48.1314 18.9686 48.6768 19.1111 49.2221C19.1556 49.1828 19.2033 49.1471 19.2535 49.1154C19.0211 48.52 18.9317 47.8785 18.9924 47.2423H18.8618Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.289 47.2423H18.7311V49.2102H19.289V47.2423Z",
    fill: "url(#paint84_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 2,
    height: 3
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 47.2423C18.8618 47.2423 18.8618 47.2423 18.8618 47.3134V47.4201L18.7194 47.5743C18.8262 48.1314 18.9686 48.6768 19.1111 49.2221C19.1556 49.1828 19.2033 49.1471 19.2535 49.1154C19.0211 48.52 18.9317 47.8785 18.9924 47.2423H18.8618Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.289 47.2423H18.7311V49.2102H19.289V47.2423Z",
    fill: "url(#paint85_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 1,
    height: 1
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 47.2423C18.8674 47.2657 18.8674 47.2901 18.8618 47.3134C18.8618 47.3134 18.8737 47.266 18.8618 47.2423Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8737 47.2423H18.8618V47.3016H18.8737V47.2423Z",
    fill: "url(#paint86_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 1,
    height: 1
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 47.2423C18.8674 47.2657 18.8674 47.2901 18.8618 47.3134C18.8618 47.3134 18.8737 47.266 18.8618 47.2423Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8737 47.2423H18.8618V47.3016H18.8737V47.2423Z",
    fill: "url(#paint87_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 47,
    width: 1,
    height: 1
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8618 47.2423C18.8674 47.2657 18.8674 47.2901 18.8618 47.3134C18.8618 47.3134 18.8737 47.266 18.8618 47.2423Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8737 47.2423H18.8618V47.3016H18.8737V47.2423Z",
    fill: "url(#paint88_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 47,
    width: 2,
    height: 3
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2596 48.4872C66.183 48.672 66.0917 48.8504 65.9866 49.0206C65.9866 49.0206 65.9866 49.0206 65.9866 49.0918L66.0579 48.8902L66.2596 49.0562C66.4021 48.5109 66.5327 47.9537 66.6514 47.3846L66.5564 47.278C66.5061 47.6862 66.3982 48.0854 66.2359 48.4635",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6751 47.278H65.9866V49.0918H66.6751V47.278Z",
    fill: "url(#paint89_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 47,
    width: 2,
    height: 3
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2596 48.4872C66.183 48.672 66.0917 48.8504 65.9866 49.0206C65.9866 49.0206 65.9866 49.0206 65.9866 49.0918L66.0579 48.8902L66.2596 49.0562C66.4021 48.5109 66.5327 47.9537 66.6514 47.3846L66.5564 47.278C66.5061 47.6862 66.3982 48.0854 66.2359 48.4635",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6751 47.278H65.9866V49.0918H66.6751V47.278Z",
    fill: "url(#paint90_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 45,
    width: 1,
    height: 3
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7819 45.5233C66.7961 46.1809 66.6494 46.832 66.3546 47.4201H66.4733C66.4631 47.3693 66.4631 47.3169 66.4733 47.266L66.687 47.1712C66.7899 46.6259 66.8729 46.0687 66.9363 45.4996H66.7582",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.96 45.5115H66.3546V47.432H66.96V45.5115Z",
    fill: "url(#paint91_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 45,
    width: 1,
    height: 3
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7819 45.5233C66.7961 46.1809 66.6494 46.832 66.3546 47.4201H66.4733C66.4631 47.3693 66.4631 47.3169 66.4733 47.266L66.687 47.1712C66.7899 46.6259 66.8729 46.0687 66.9363 45.4996H66.7582",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.96 45.5115H66.3546V47.432H66.96V45.5115Z",
    fill: "url(#paint92_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 37,
    width: 1,
    height: 3
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4733 37.8531C66.5855 38.2386 66.6454 38.6373 66.6513 39.0387C66.6695 39.2398 66.6695 39.4421 66.6513 39.6433V39.7025V39.4891L66.9481 39.584C66.8769 39.0149 66.7819 38.3985 66.6751 37.8887L66.4733 37.8531Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9361 37.8531H66.485V39.75H66.9361V37.8531Z",
    fill: "url(#paint93_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 37,
    width: 1,
    height: 3
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4733 37.8531C66.5855 38.2386 66.6454 38.6373 66.6513 39.0387C66.6695 39.2398 66.6695 39.4421 66.6513 39.6433V39.7025V39.4891L66.9481 39.584C66.8769 39.0149 66.7819 38.3985 66.6751 37.8887L66.4733 37.8531Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9361 37.8531H66.485V39.75H66.9361V37.8531Z",
    fill: "url(#paint94_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 29,
    width: 2,
    height: 2
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9122 29.116V29.1753C63.1439 29.4879 63.339 29.826 63.4939 30.1829C63.5651 30.3845 63.6244 30.5742 63.6719 30.7638H63.7431L63.6482 30.5623H63.9449C63.6601 30.0644 63.3514 29.5783 63.0428 29.1041L62.9122 29.116Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9212 29.116H62.8529V30.7994H63.9212V29.116Z",
    fill: "url(#paint95_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 29,
    width: 2,
    height: 2
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9122 29.116V29.1753C63.1439 29.4879 63.339 29.826 63.4939 30.1829C63.5651 30.3845 63.6244 30.5742 63.6719 30.7638H63.7431L63.6482 30.5623H63.9449C63.6601 30.0644 63.3514 29.5783 63.0428 29.1041L62.9122 29.116Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9212 29.116H62.8529V30.7994H63.9212V29.116Z",
    fill: "url(#paint96_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 35,
    width: 1,
    height: 3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0697 36.1224C66.3088 36.6958 66.4143 37.316 66.3783 37.9362H66.4733C66.4614 37.8815 66.4614 37.8249 66.4733 37.7702L66.6157 37.6161C66.5089 37.0708 66.3665 36.5136 66.2121 35.9801L66.0816 36.0868",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6039 36.0156H66.0341V37.9836H66.6039V36.0156Z",
    fill: "url(#paint97_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 35,
    width: 1,
    height: 3
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0697 36.1224C66.3088 36.6958 66.4143 37.316 66.3783 37.9362H66.4733C66.4614 37.8815 66.4614 37.8249 66.4733 37.7702L66.6157 37.6161C66.5089 37.0708 66.3665 36.5136 66.2121 35.9801L66.0816 36.0868",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6039 36.0156H66.0341V37.9954H66.6039V36.0156Z",
    fill: "url(#paint98_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 27,
    width: 2,
    height: 3
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8083 27.6104C62.2726 28.0609 62.6261 28.6128 62.841 29.2227H62.9122C62.9122 29.2227 62.9122 29.2227 62.9122 29.1634V29.0686C62.9142 29.0291 62.9142 28.9895 62.9122 28.95C62.5917 28.4877 62.2594 28.0253 61.9033 27.5867C61.9067 27.6103 61.9067 27.6342 61.9033 27.6578",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8766 27.5393H61.7727V29.2227H62.8766V27.5393Z",
    fill: "url(#paint99_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 27,
    width: 2,
    height: 3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8083 27.6104C62.2726 28.0609 62.6261 28.6128 62.841 29.2227H62.9122C62.9122 29.2227 62.9122 29.2227 62.9122 29.1634V29.0686C62.9142 29.0291 62.9142 28.9895 62.9122 28.95C62.5917 28.4877 62.2594 28.0253 61.9033 27.5867C61.9067 27.6103 61.9067 27.6342 61.9033 27.6578",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8766 27.5393H61.7727V29.2227H62.8766V27.5393Z",
    fill: "url(#paint100_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 2,
    height: 2
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2411 22.3705L56.3242 22.4298C56.6258 22.6185 56.9046 22.8413 57.1552 23.0936C57.2986 23.2322 57.4296 23.3829 57.5469 23.5441H57.63L57.4638 23.4019L57.6418 23.307C57.1789 23.0107 56.716 22.6787 56.2411 22.3705Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6181 22.3705H56.2411V23.6034H57.6181V22.3705Z",
    fill: "url(#paint101_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 2,
    height: 2
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2411 22.3705L56.3242 22.4298C56.6258 22.6185 56.9046 22.8413 57.1552 23.0936C57.2986 23.2322 57.4296 23.3829 57.5469 23.5441H57.63L57.4638 23.4019L57.6418 23.307C57.1789 23.0107 56.716 22.6787 56.2411 22.3705Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6181 22.3705H56.2411V23.5916H57.6181V22.3705Z",
    fill: "url(#paint102_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 18,
    width: 2,
    height: 2
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4424 18.968L48.6917 19.051C48.8744 19.1323 49.0528 19.2233 49.2258 19.3237H49.297L49.0952 19.2525L49.1665 19.1696C48.9291 19.0747 48.6679 18.968 48.4424 18.968Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.297 18.9562H48.4424V19.3237H49.297V18.9562Z",
    fill: "url(#paint103_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 18,
    width: 2,
    height: 2
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4424 18.968L48.6917 19.051C48.8744 19.1323 49.0528 19.2233 49.2258 19.3237H49.297L49.0952 19.2525L49.1665 19.1696C48.9291 19.0747 48.6679 18.968 48.4424 18.968Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.297 18.9562H48.4424V19.3237H49.297V18.9562Z",
    fill: "url(#paint104_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 1,
    height: 1
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1699 22.3823C56.1948 22.4268 56.2269 22.4669 56.2649 22.5009L56.1699 22.3823Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3005 22.3823H56.1699V22.489H56.3005V22.3823Z",
    fill: "url(#paint105_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 1,
    height: 1
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1699 22.3823C56.1948 22.4268 56.2269 22.4669 56.2649 22.5009L56.1699 22.3823Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3005 22.3823H56.1699V22.489H56.3005V22.3823Z",
    fill: "url(#paint106_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 22,
    width: 2,
    height: 1
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9444 22.1689C56.0174 22.2301 56.085 22.2975 56.1462 22.3705H56.2174L55.9444 22.1689Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2174 22.1689H55.9444V22.3705H56.2174V22.1689Z",
    fill: "url(#paint107_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 22,
    width: 2,
    height: 1
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9444 22.1689C56.0174 22.2301 56.085 22.2975 56.1462 22.3705H56.2174L55.9444 22.1689Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2174 22.1689H55.9444V22.3705H56.2174V22.1689Z",
    fill: "url(#paint108_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 1,
    height: 1
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1462 22.3705L56.2768 22.4535L56.1937 22.3942H56.1224",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3242 22.3468H56.1462V22.4654H56.3242V22.3468Z",
    fill: "url(#paint109_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 1,
    height: 1
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1462 22.3705L56.2768 22.4535L56.1937 22.3942H56.1224",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3242 22.3468H56.1462V22.4654H56.3242V22.3468Z",
    fill: "url(#paint110_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 22,
    width: 1,
    height: 1
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1462 22.3705L56.2768 22.4535L56.1937 22.3942H56.1224",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3242 22.3468H56.1462V22.4654H56.3242V22.3468Z",
    fill: "url(#paint111_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 18,
    width: 3,
    height: 1
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M45.736 18.5532C46.3849 18.545 47.0268 18.687 47.6115 18.9681V18.8851C47.5564 18.8932 47.5004 18.8932 47.4453 18.8851C47.4482 18.8456 47.4482 18.806 47.4453 18.7665C46.8874 18.6599 46.3295 18.5769 45.7598 18.5057C45.7651 18.5371 45.7651 18.5692 45.7598 18.6006",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6115 18.4584H45.6885V18.9919H47.6115V18.4584Z",
    fill: "url(#paint112_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 18,
    width: 3,
    height: 1
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M45.736 18.5532C46.3849 18.545 47.0268 18.687 47.6115 18.9681V18.8851C47.5564 18.8932 47.5004 18.8932 47.4453 18.8851C47.4482 18.8456 47.4482 18.806 47.4453 18.7665C46.8874 18.6599 46.3295 18.5769 45.7598 18.5057C45.7651 18.5371 45.7651 18.5692 45.7598 18.6006",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6115 18.4584H45.6885V18.9919H47.6115V18.4584Z",
    fill: "url(#paint113_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 18,
    width: 2,
    height: 1
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1034 18.6954L38.0322 18.8377H38.1153C38.5018 18.7308 38.9014 18.6789 39.3023 18.6835C39.5039 18.6713 39.7061 18.6713 39.9077 18.6835H39.9671H39.7415C39.7415 18.6006 39.8009 18.5176 39.8365 18.4227C39.2667 18.4939 38.6495 18.5768 38.1509 18.6835",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9196 18.4346H38.0322V18.8376H39.9196V18.4346Z",
    fill: "url(#paint114_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 18,
    width: 2,
    height: 1
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1034 18.6954L38.0322 18.8377H38.1153C38.5018 18.7308 38.9014 18.6789 39.3023 18.6835C39.5039 18.6713 39.7061 18.6713 39.9077 18.6835H39.9671H39.7415C39.7415 18.6006 39.8009 18.5176 39.8365 18.4227C39.2667 18.4939 38.6495 18.5768 38.1509 18.6835",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9196 18.4346H38.0322V18.8376H39.9196V18.4346Z",
    fill: "url(#paint115_radial_187_41690)"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8149 42.6781C71.8149 48.4341 70.1053 54.0606 66.9024 58.8459C63.6995 63.6311 59.1472 67.3599 53.8217 69.5604C48.4963 71.7609 42.6368 72.3343 36.985 71.2079C31.3331 70.0815 26.1428 67.306 22.0709 63.2327C17.9989 59.1593 15.2283 53.9711 14.1097 48.3246C12.9911 42.6782 13.5748 36.8272 15.7868 31.5121C17.9988 26.197 21.7398 21.6567 26.5364 18.4657C31.333 15.2747 36.9695 13.5765 42.7328 13.5859C50.4502 13.5984 57.8473 16.669 63.2998 22.1235C68.7524 27.578 71.8149 34.9706 71.8149 42.6781Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8149 42.6781C71.8149 48.4341 70.1053 54.0606 66.9024 58.8459C63.6995 63.6311 59.1472 67.3599 53.8217 69.5604C48.4963 71.7609 42.6368 72.3343 36.985 71.2079C31.3331 70.0815 26.1428 67.306 22.0709 63.2327C17.9989 59.1593 15.2283 53.9711 14.1097 48.3246C12.9911 42.6782 13.5748 36.8272 15.7868 31.5121C17.9988 26.197 21.7398 21.6567 26.5364 18.4657C31.333 15.2747 36.9695 13.5765 42.7328 13.5859C50.4502 13.5984 57.8473 16.669 63.2998 22.1235C68.7524 27.578 71.8149 34.9706 71.8149 42.6781Z",
    stroke: "#AD8400",
    strokeWidth: 0.13
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 60,
    height: 60
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3065 42.6782C13.3065 48.4793 15.0284 54.1503 18.2545 58.9744C21.4806 63.7985 26.0661 67.5592 31.4316 69.7814C36.7971 72.0035 42.7018 72.5874 48.3994 71.4591C54.0971 70.3308 59.3319 67.541 63.4425 63.4423C67.5531 59.3436 70.3549 54.1199 71.4939 48.4314C72.6328 42.7429 72.0578 36.8448 69.8414 31.4826C67.6251 26.1204 63.8669 21.5346 59.0419 18.3049C54.2168 15.0751 48.5414 13.3463 42.7328 13.337C38.8707 13.3307 35.0453 14.0851 31.4754 15.5568C27.9056 17.0285 24.6613 19.1888 21.9282 21.914C19.195 24.6392 17.0268 27.8759 15.5474 31.4388C14.068 35.0018 13.3065 38.821 13.3065 42.6782Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0523 13.3369H13.3065V72.0075H72.0523V13.3369Z",
    fill: "url(#paint116_radial_187_41690)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 29,
    height: 49
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3759 15.9687C29.6224 16.2829 28.889 16.6432 28.1799 17.0475L26.162 18.233L24.7732 19.3118C24.0253 19.8572 23.3725 20.4025 22.6721 21.019C21.7049 21.7919 20.8984 22.7464 20.2981 23.8286C20.1295 24.0583 20.0011 24.3148 19.9182 24.5873C19.6341 24.8615 19.4186 25.1985 19.2891 25.5713C19.3231 25.7018 19.3151 25.8396 19.266 25.9652C19.217 26.0908 19.1295 26.1977 19.0161 26.2708C18.7899 26.4388 18.6207 26.6722 18.5316 26.9393C18.4424 27.2064 18.4375 27.4945 18.5175 27.7645C18.5557 27.89 18.568 28.0219 18.5537 28.1523C18.5394 28.2827 18.4988 28.4089 18.4345 28.5232C18.0609 29.0934 17.844 29.7516 17.8053 30.4319C17.7816 30.6406 17.7816 30.8514 17.8053 31.0602C18.1327 31.8295 18.183 32.6883 17.9478 33.4905C17.8823 33.6664 17.8823 33.8599 17.9478 34.0358C18.1652 34.3904 18.3595 34.7587 18.5294 35.1383C18.5406 35.4804 18.6286 35.8157 18.7868 36.1193C18.945 36.423 19.1694 36.6873 19.4434 36.8929C19.6233 36.9479 19.7848 37.051 19.9103 37.191C20.0358 37.331 20.1206 37.5025 20.1556 37.6872C20.2134 38.0116 20.3383 38.3204 20.5222 38.5939C20.7061 38.8674 20.9451 39.0996 21.224 39.2757C22.0971 39.5763 22.953 39.9246 23.7879 40.319C24.6972 40.5078 25.5166 40.9963 26.1145 41.706C26.2629 41.829 26.4265 41.9326 26.6012 42.0143C27.1636 42.3921 27.8131 42.6206 28.4885 42.6781C28.637 42.6891 28.78 42.7381 28.904 42.8204C29.0648 42.9674 29.1821 43.1558 29.2428 43.3649C29.3035 43.574 29.3054 43.7958 29.2482 44.0059C29.1607 44.3374 28.9937 44.6425 28.7616 44.895C28.7616 45.144 28.7616 45.4404 28.7616 45.6893C28.6862 46.1676 28.6544 46.6517 28.6666 47.1356C28.9136 47.5139 29.1319 47.9102 29.3195 48.3211C29.4663 48.9683 29.8007 49.5579 30.2809 50.0164C30.6622 50.1655 31.0313 50.3438 31.3849 50.5499C31.8003 50.8344 32.2989 51.0241 32.5719 51.4864L32.7381 52.9683C33.0865 53.5486 33.2248 54.2308 33.1298 54.9007C33.2531 55.1602 33.4087 55.4031 33.5927 55.6238C33.8947 55.9595 34.1034 56.3682 34.1981 56.8093C34.1912 57.6861 34.3234 58.5584 34.5898 59.3937C34.756 59.9154 35.1833 60.2473 35.1715 60.9586C35.3583 61.5703 35.5966 62.1652 35.8837 62.7369C35.9386 62.931 36.035 63.111 36.1661 63.2645C36.2972 63.4179 36.46 63.5413 36.6434 63.626C37.0303 63.7291 37.434 63.7533 37.8304 63.6971C38.002 63.6743 38.1674 63.6179 38.3171 63.5312C38.3599 63.4061 38.3682 63.2718 38.341 63.1425C38.3139 63.0131 38.2523 62.8935 38.1628 62.7962C37.9372 62.5709 37.5574 62.2864 37.7354 61.824C37.6449 61.2824 37.434 60.768 37.1182 60.3184C37.0909 60.2314 37.0864 60.1389 37.1051 60.0497C37.1238 59.9604 37.1651 59.8774 37.225 59.8087C37.403 59.5875 37.4957 59.3099 37.4862 59.0262C37.4829 58.887 37.5235 58.7503 37.6024 58.6354C37.6812 58.5205 37.7942 58.4333 37.9254 58.3861C38.1114 58.3468 38.2825 58.2559 38.419 58.1237C38.5555 57.9916 38.6518 57.8236 38.6969 57.6392C38.75 57.3068 38.9113 57.0012 39.156 56.7697C39.4007 56.5382 39.7149 56.3938 40.0501 56.3589C40.4062 56.3589 40.7386 56.2403 40.8098 55.9558C41.0799 54.8042 41.4371 53.6747 41.8782 52.5771C42.2773 52.2088 42.7197 51.8904 43.1958 51.6287C43.5197 51.4576 43.8094 51.2286 44.0504 50.953C44.3031 50.5089 44.4872 50.0293 44.5964 49.5303C44.7801 48.4945 45.1544 47.5017 45.7004 46.6022C45.7537 46.4486 45.7537 46.2815 45.7004 46.128C45.3311 45.6439 44.8666 45.2404 44.3353 44.9424C44.0151 44.8717 43.6895 44.828 43.3619 44.812C42.899 44.6461 42.626 44.3616 42.2461 44.1956C41.8828 44.1648 41.5174 44.1648 41.1541 44.1956H40.8929C40.2994 44.1956 39.8127 44.0296 39.7059 43.5317C39.1577 43.0119 38.4754 42.6547 37.7354 42.5003C36.9879 41.9837 36.193 41.5392 35.3614 41.1725C34.8757 40.6731 34.2515 40.3304 33.569 40.1886C33.362 40.2337 33.1515 40.2614 32.9399 40.2716C32.7342 40.4231 32.5434 40.5938 32.3701 40.7813C32.298 40.8916 32.1912 40.9748 32.0666 41.0177C31.9419 41.0607 31.8065 41.0609 31.6816 41.0184C31.6026 40.9204 31.4921 40.8526 31.3687 40.8267C31.2454 40.8008 31.1169 40.8183 31.005 40.8762L30.1385 41.3267C29.6808 41.6241 29.1407 41.7693 28.5954 41.7416L27.1828 39.667C27.0048 39.5484 26.9217 39.2994 26.613 39.3469C26.3044 39.3943 26.3044 39.4417 26.162 39.3469C26.0195 39.252 26.162 39.1809 26.162 39.0979C26.239 38.9557 26.2862 38.7993 26.3005 38.6382C26.3147 38.4772 26.2959 38.3149 26.2451 38.1614C26.2144 38.0567 26.1565 37.9621 26.0772 37.8872C25.998 37.8122 25.9002 37.7595 25.794 37.7346C25.6417 37.7696 25.4834 37.7696 25.3311 37.7346C24.88 37.8294 24.6663 38.2088 24.3696 38.4577C24.3088 38.5058 24.2335 38.532 24.1559 38.532C24.0783 38.532 24.0031 38.5058 23.9422 38.4577C23.822 38.3092 23.7514 38.1268 23.7404 37.9361V37.3434C23.7008 37.1478 23.7008 36.9462 23.7404 36.7506C23.948 36.3585 24.0656 35.9252 24.0847 35.4821C24.0757 35.3509 24.1136 35.2207 24.1915 35.1146C24.4697 34.9478 24.7823 34.8464 25.1055 34.8182C25.3619 34.6391 25.6511 34.5123 25.9567 34.4451C26.2623 34.378 26.5781 34.3718 26.8861 34.427C27.217 34.6146 27.4979 34.8789 27.7051 35.1976C27.9188 35.4584 28.1087 35.8022 28.5598 35.7904C28.6428 35.7904 28.7378 35.6955 28.7734 35.6007C28.7979 35.4316 28.7979 35.2599 28.7734 35.0909C28.6775 34.771 28.5419 34.4644 28.3698 34.1781C28.3153 34.0516 28.3107 33.9092 28.3569 33.7794C28.4031 33.6497 28.4968 33.5422 28.6191 33.4786C29.4782 33.1835 30.2495 32.6781 30.8626 32.0086C31.0896 31.2221 31.4643 30.4859 31.9665 29.8391C32.6115 29.6084 33.1761 29.1968 33.5927 28.6536C33.7779 28.4286 33.8861 28.1502 33.9014 27.8593C33.9013 27.8121 33.8864 27.7661 33.8587 27.7278C33.831 27.6895 33.7919 27.6609 33.747 27.6459C33.5617 27.5869 33.3626 27.5869 33.1773 27.6459C32.9755 27.7289 32.7974 27.8593 32.56 27.7882C32.3226 27.7171 32.4888 27.6104 32.56 27.5511C32.9318 27.2024 33.3912 26.9607 33.8895 26.8517C34.2575 26.9702 34.5542 27.1125 34.8272 27.1836C35.0733 27.1483 35.3108 27.0679 35.5276 26.9465C35.9787 26.7094 36.0143 25.8677 35.7175 25.429C35.6107 25.2749 35.397 25.2631 35.2546 25.2038C35.005 24.9907 34.7783 24.7523 34.578 24.4925C34.483 24.1724 34.578 23.7101 34.4593 23.307C34.385 23.0974 34.2533 22.913 34.079 22.7746C33.9048 22.6363 33.6952 22.5496 33.474 22.5246C33.0414 22.5914 32.601 22.5914 32.1683 22.5246C32.109 22.5246 32.0259 22.6075 31.9903 22.6787C31.8613 23.1914 31.6132 23.6666 31.2662 24.0657C30.8288 24.3833 30.3494 24.6386 29.8417 24.8244C29.7919 24.8344 29.7403 24.8308 29.6923 24.8142C29.6443 24.7975 29.6016 24.7683 29.5687 24.7296L29.1058 24.1606C28.9067 24.095 28.7123 24.0158 28.5241 23.9235C28.4292 23.9235 28.2986 23.8168 28.3224 23.6982C28.3461 23.5797 28.5004 23.39 28.5241 23.307C28.5479 23.224 28.5241 22.8921 28.5241 22.6787C28.71 22.5335 28.9248 22.4298 29.1541 22.3746C29.3835 22.3194 29.622 22.3139 29.8536 22.3586C30.0149 22.4076 30.1844 22.4239 30.3521 22.4068C30.5198 22.3897 30.6825 22.3394 30.8305 22.2588C30.9786 22.1783 31.1091 22.0691 31.2145 21.9376C31.3198 21.8062 31.3979 21.6551 31.4442 21.4932C31.4314 21.3928 31.443 21.2907 31.4782 21.1958C31.5133 21.1008 31.5709 21.0158 31.646 20.9478C31.8597 20.7937 32.192 20.7819 32.382 20.6159C32.4568 20.5294 32.5024 20.4215 32.5125 20.3077C32.5317 20.2082 32.5848 20.1185 32.6626 20.0537C32.7405 19.9888 32.8385 19.9529 32.9399 19.952C33.0723 19.9699 33.2007 20.01 33.3197 20.0706C33.5334 20.2128 33.6046 20.5211 33.7233 20.77C33.777 20.9215 33.8665 21.0577 33.9843 21.1672C34.1022 21.2766 34.2447 21.3559 34.3999 21.3983C34.4509 21.4083 34.5036 21.4036 34.552 21.3847C34.6003 21.3658 34.6423 21.3335 34.6729 21.2916C35.0387 20.7044 35.1936 20.0104 35.1121 19.3237C35.0991 19.2456 35.0751 19.1698 35.0409 19.0985C34.9459 18.8376 34.578 18.7072 34.1744 18.7191C33.8243 18.4559 33.4913 18.1708 33.1773 17.8655C32.9941 17.7294 32.8473 17.5502 32.7499 17.3439C32.7499 17.3439 32.6669 17.3439 32.6075 17.3439H32.4769C32.3153 17.2346 32.1445 17.1394 31.9665 17.0594C31.7734 17.0356 31.578 17.0356 31.3849 17.0594C31.1712 16.6563 30.9101 16.3599 30.7557 15.9806H30.6489C30.5508 15.9625 30.4503 15.9625 30.3522 15.9806",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7241 15.9213H17.8054V63.7801H45.7241V15.9213Z",
    fill: "url(#paint117_radial_187_41690)"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4885 41.6586C29.0339 41.6864 29.574 41.5412 30.0317 41.2437L30.8982 40.7932C31.0101 40.7353 31.1386 40.7178 31.2619 40.7438C31.3852 40.7697 31.4958 40.8374 31.5748 40.9355C31.6996 40.978 31.8351 40.9777 31.9597 40.9348C32.0844 40.8919 32.1912 40.8087 32.2633 40.6984C32.4366 40.5108 32.6274 40.3401 32.833 40.1886C33.0447 40.1785 33.2551 40.1507 33.4622 40.1056C34.1446 40.2475 34.7689 40.5902 35.2546 41.0896C36.0862 41.4562 36.8811 41.9008 37.6286 42.4174C38.3703 42.5669 39.0539 42.9247 39.5991 43.4488C39.7534 43.9467 40.2401 44.1126 40.7861 44.1126C41.2404 44.0761 41.6969 44.0761 42.1512 44.1126C42.5191 44.2786 42.804 44.5631 43.2551 44.7291C43.5827 44.7451 43.9083 44.7887 44.2285 44.8595C44.7597 45.1575 45.2243 45.5609 45.5935 46.045C45.6469 46.1986 45.6469 46.3656 45.5935 46.5192C45.0495 47.4197 44.6754 48.4122 44.4896 49.4474C44.3803 49.9464 44.1962 50.426 43.9436 50.87C43.7025 51.1456 43.4128 51.3747 43.0889 51.5457C42.6129 51.8074 42.1704 52.1259 41.7713 52.4942C41.3302 53.5918 40.9731 54.7213 40.703 55.8728C40.6318 56.1574 40.2994 56.2878 39.9433 56.2759C39.6081 56.3109 39.2938 56.4553 39.0492 56.6868C38.8045 56.9182 38.6431 57.2239 38.5901 57.5563C38.545 57.7407 38.4487 57.9087 38.3122 58.0408C38.1756 58.1729 38.0045 58.2639 37.8185 58.3031C37.6874 58.3503 37.5743 58.4376 37.4955 58.5524C37.4167 58.6673 37.3761 58.8041 37.3793 58.9433C37.3881 59.2285 37.3002 59.5084 37.1301 59.7376C37.0647 59.8005 37.0187 59.8809 36.9977 59.9692C36.9766 60.0574 36.9814 60.1499 37.0114 60.2355C37.3272 60.685 37.5381 61.1995 37.6286 61.7411C37.4506 62.2034 37.8304 62.488 38.0559 62.7132C38.1455 62.8105 38.207 62.9302 38.2342 63.0595C38.2613 63.1889 38.2531 63.3232 38.2103 63.4482C38.0605 63.5349 37.8951 63.5913 37.7236 63.6142C37.3271 63.6704 36.9234 63.6462 36.5366 63.5431C36.3532 63.4583 36.1904 63.335 36.0593 63.1815C35.9281 63.0281 35.8318 62.8481 35.7769 62.6539C35.4897 62.0823 35.2515 61.4874 35.0646 60.8757C35.0646 60.1644 34.6492 59.8324 34.483 59.3227C34.218 58.4829 34.0859 57.6069 34.0913 56.7264C33.9966 56.2852 33.7879 55.8765 33.4859 55.5409C33.3018 55.3202 33.1463 55.0772 33.023 54.8177C33.118 54.1478 32.9797 53.4656 32.6312 52.8854L32.4651 51.4035C32.2039 50.9411 31.7054 50.7515 31.278 50.4669C30.9244 50.2609 30.5553 50.0825 30.1741 49.9335C29.6964 49.4777 29.3623 48.8927 29.2126 48.25C29.0272 47.838 28.8089 47.4416 28.5598 47.0645C28.5476 46.5806 28.5794 46.0965 28.6547 45.6182C28.6547 45.3693 28.6547 45.0729 28.6547 44.8239C28.8893 44.5732 29.0567 44.2674 29.1414 43.9348C29.1986 43.7247 29.1967 43.5029 29.136 43.2938C29.0752 43.0847 28.958 42.8963 28.7972 42.7493C28.6995 42.7069 28.5949 42.6827 28.4885 42.6782C27.8129 42.6045 27.1673 42.3597 26.613 41.9669C26.4404 41.8881 26.2804 41.7842 26.1382 41.6586C25.5346 40.9685 24.7219 40.494 23.8235 40.3072C22.9886 39.9128 22.1327 39.5645 21.2596 39.2639C20.9807 39.0878 20.7417 38.8556 20.5578 38.5821C20.3739 38.3085 20.249 37.9997 20.1912 37.6753C20.1562 37.4907 20.0714 37.3191 19.9459 37.1792C19.8204 37.0392 19.6589 36.9361 19.479 36.8811C19.205 36.6755 18.9806 36.4112 18.8224 36.1075C18.6642 35.8039 18.5763 35.4686 18.565 35.1265C18.3943 34.7494 18.2041 34.3814 17.9953 34.024C17.924 33.8492 17.924 33.6535 17.9953 33.4787C18.2127 32.6747 18.1456 31.8205 17.8053 31.0602C17.7816 30.8515 17.7816 30.6407 17.8053 30.4319C17.8449 29.7701 18.0533 29.1294 18.4107 28.5707C18.4751 28.4563 18.5157 28.3302 18.5299 28.1998C18.5442 28.0694 18.5319 27.9375 18.4938 27.812C18.4147 27.5437 18.4201 27.2576 18.5093 26.9926C18.5985 26.7275 18.7671 26.4962 18.9924 26.3301C19.1055 26.2538 19.1923 26.1447 19.2412 26.0174C19.29 25.8902 19.2985 25.751 19.2654 25.6188C19.3948 25.246 19.6104 24.9089 19.8945 24.6348C19.9774 24.3623 20.1058 24.1058 20.2743 23.8761C20.8788 22.7967 21.6847 21.843 22.6484 21.0664C23.3487 20.45 24.0016 19.8809 24.7494 19.3593L26.1145 18.2805L28.1324 17.095C28.8415 16.6906 29.5749 16.3304 30.3284 16.0162C30.4612 15.9853 30.5993 15.9853 30.732 16.0162C30.8863 16.3955 31.1475 16.6919 31.3611 17.095C31.5543 17.0712 31.7496 17.0712 31.9428 17.095C32.1208 17.175 32.2916 17.2702 32.4532 17.3795C32.5482 17.3795 32.6906 17.3795 32.7262 17.4388C32.8235 17.6451 32.9703 17.8243 33.1535 17.9604C33.4691 18.2685 33.8063 18.5537 34.1625 18.814C34.5542 18.814 34.9222 18.9325 35.0172 19.1933C35.0514 19.2647 35.0754 19.3405 35.0884 19.4186C35.1732 20.0844 35.0355 20.7595 34.6967 21.3391C34.666 21.381 34.6241 21.4133 34.5757 21.4322C34.5274 21.451 34.4746 21.4558 34.4237 21.4458C34.2685 21.4033 34.1259 21.324 34.0081 21.2146C33.8903 21.1052 33.8007 20.969 33.747 20.8175C33.6283 20.5685 33.5571 20.2603 33.3435 20.118C33.2244 20.0574 33.096 20.0174 32.9636 19.9995C32.8622 20.0004 32.7643 20.0363 32.6864 20.1011C32.6085 20.166 32.5555 20.2557 32.5363 20.3551C32.5262 20.469 32.4805 20.5768 32.4057 20.6634C32.2158 20.8293 31.8834 20.8412 31.6698 20.9953C31.5946 21.0632 31.537 21.1483 31.5019 21.2433C31.4668 21.3382 31.4551 21.4402 31.468 21.5406C31.4217 21.7025 31.3436 21.8536 31.2382 21.9851C31.1328 22.1165 31.0023 22.2257 30.8543 22.3063C30.7062 22.3868 30.5436 22.4371 30.3759 22.4543C30.2081 22.4714 30.0387 22.455 29.8774 22.4061C29.6457 22.3614 29.4072 22.3668 29.1779 22.4221C28.9485 22.4773 28.7337 22.581 28.5479 22.7261C28.4767 22.9395 28.5479 23.1529 28.5479 23.3545C28.5479 23.556 28.3698 23.6627 28.3461 23.7457C28.3224 23.8287 28.4529 23.9354 28.5479 23.9709C28.7361 24.0633 28.9304 24.1425 29.1295 24.208L29.5925 24.7889C29.6637 24.8482 29.7943 24.9075 29.8655 24.8719C30.3732 24.6861 30.8526 24.4307 31.2899 24.1132C31.6531 23.7108 31.9137 23.2269 32.0496 22.7024C32.0496 22.6313 32.1683 22.5483 32.2277 22.5483C32.6603 22.6151 33.1007 22.6151 33.5334 22.5483C33.7676 22.5816 33.9866 22.684 34.1621 22.8424C34.3377 23.0008 34.4618 23.2081 34.5186 23.4374C34.6017 23.7812 34.5186 24.2436 34.6373 24.6229C34.8376 24.8828 35.0644 25.1212 35.3139 25.3342C35.4564 25.3935 35.6819 25.4054 35.7769 25.5595C36.0736 25.9981 36.038 26.8398 35.5869 27.0769C35.3701 27.1984 35.1327 27.2788 34.8866 27.314C34.6136 27.2429 34.3168 27.1007 33.9488 26.9821C33.4506 27.0911 32.9912 27.3328 32.6194 27.6815C32.56 27.7408 32.5125 27.8831 32.6194 27.9186C32.7262 27.9542 33.0348 27.9186 33.2366 27.7764C33.426 27.7172 33.6289 27.7172 33.8183 27.7764C33.8609 27.7933 33.8974 27.8227 33.9229 27.8609C33.9483 27.899 33.9615 27.944 33.9607 27.9898C33.9454 28.2807 33.8373 28.559 33.6521 28.7841C33.2355 29.3272 32.6708 29.7389 32.0259 29.9696C31.5167 30.5726 31.1225 31.2637 30.8626 32.0086C30.2743 32.6848 29.5224 33.1991 28.6785 33.5024C28.5562 33.566 28.4625 33.6734 28.4162 33.8032C28.37 33.9329 28.3746 34.0753 28.4292 34.2018C28.6013 34.4881 28.7369 34.7948 28.8328 35.1147C28.8632 35.2832 28.8632 35.4559 28.8328 35.6244C28.8328 35.7193 28.7022 35.8141 28.6191 35.8141C28.168 35.8141 27.9781 35.4822 27.7645 35.2214C27.5572 34.9027 27.2763 34.6384 26.9454 34.4508C26.6375 34.3956 26.3216 34.4017 26.016 34.4689C25.7105 34.536 25.4212 34.6628 25.1649 34.842C24.8416 34.8702 24.529 34.9715 24.2509 35.1384C24.1729 35.2444 24.1351 35.3746 24.144 35.5059C24.1033 35.9455 23.9654 36.3706 23.7404 36.7507C23.6746 36.9369 23.6463 37.1343 23.6574 37.3316V37.9362C23.6879 38.0894 23.7574 38.2323 23.8591 38.3511C23.92 38.3992 23.9952 38.4253 24.0728 38.4253C24.1504 38.4253 24.2257 38.3992 24.2865 38.3511C24.5832 38.1021 24.7969 37.7228 25.248 37.6279C25.4003 37.6629 25.5586 37.6629 25.7109 37.6279C25.8172 37.6529 25.9149 37.7055 25.9941 37.7805C26.0734 37.8555 26.1313 37.9501 26.162 38.0547C26.2382 38.2239 26.2736 38.4085 26.2653 38.5938C26.2571 38.7791 26.2054 38.9599 26.1145 39.1217C26.1145 39.2046 26.1145 39.3351 26.1145 39.3706C26.1145 39.4062 26.4231 39.3706 26.5656 39.3706C26.708 39.3706 26.9573 39.5722 27.1353 39.6907",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 66,
    width: 23,
    height: 7
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3588 66.08C40.1058 66.1813 39.881 66.3419 39.7033 66.5482C39.5256 66.7545 39.4003 67.0006 39.3379 67.2655C39.3028 67.5265 39.1817 67.7685 38.9937 67.9531C38.7957 68.2356 38.5439 68.4764 38.2526 68.6615C37.9613 68.8466 37.6363 68.9725 37.2962 69.0319C36.9494 68.9566 36.5945 68.9248 36.2398 68.9371C35.5467 68.7039 34.8224 68.576 34.0913 68.5577L32.8568 68.7593C32.5121 68.7814 32.177 68.8815 31.8768 69.052C31.5766 69.2224 31.3191 69.4588 31.1237 69.7432C31.4089 69.9037 31.7116 70.031 32.0259 70.1226C36.0486 71.6743 40.3683 72.3063 44.6677 71.972C47.2572 71.8605 49.8111 71.3279 52.229 70.3952L53.5822 69.8144C53.1458 69.5501 52.6894 69.3202 52.2171 69.1268C51.2562 68.6905 50.2209 68.441 49.1665 68.3917C48.8147 68.4873 48.4697 68.6061 48.1338 68.7474C47.5365 68.5761 46.9136 68.5119 46.2939 68.5577L43.7299 69.4824C43.6304 69.5197 43.5208 69.5197 43.4213 69.4824C43.0177 69.4824 42.6735 69.2927 42.2343 69.269C41.9422 69.2628 41.6553 69.1915 41.3944 69.0602C41.1336 68.9289 40.9055 68.741 40.7267 68.5103C40.6623 68.1312 40.5423 67.7637 40.3706 67.4196C40.3174 67.3612 40.2789 67.2909 40.2583 67.2146C40.2376 67.1384 40.2354 67.0583 40.2519 66.981C40.3373 66.7158 40.4445 66.458 40.5724 66.2104C40.5724 66.08 40.5724 66.0326 40.4893 66.0326",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.511 66.0681H31.1237V72.3631H53.511V66.0681Z",
    fill: "url(#paint118_radial_187_41690)"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2939 68.5578C46.8946 68.5227 47.4968 68.5909 48.0744 68.7593C48.4104 68.618 48.7554 68.4992 49.1071 68.4037C50.1615 68.4529 51.1969 68.7024 52.1578 69.1387C52.6272 69.3298 53.0799 69.5598 53.511 69.8263L52.1696 70.419C49.7702 71.348 47.2377 71.8883 44.6677 72.0195C40.3753 72.3464 36.0641 71.7105 32.0496 70.1582C31.7354 70.0666 31.4327 69.9393 31.1475 69.7789C31.3366 69.4908 31.5887 69.2494 31.8848 69.0728C32.1808 68.8962 32.5132 68.789 32.8568 68.7593L34.1388 68.5696C34.8698 68.5784 35.5949 68.7024 36.2873 68.9371C36.642 68.9248 36.9969 68.9567 37.3437 69.032C37.6838 68.9726 38.0088 68.8467 38.3001 68.6616C38.5914 68.4764 38.8432 68.2357 39.0412 67.9532C39.2292 67.7685 39.3503 67.5266 39.3854 67.2656C39.4478 67.0007 39.5731 66.7546 39.7508 66.5483C39.9285 66.3419 40.1533 66.1813 40.4062 66.0801C40.4062 66.0801 40.5843 66.0801 40.5249 66.246C40.3971 66.4937 40.2899 66.7514 40.2044 67.0166C40.1891 67.0931 40.1907 67.172 40.2091 67.2478C40.2276 67.3236 40.2624 67.3944 40.3113 67.4553C40.4924 67.7965 40.6167 68.1648 40.6793 68.5459C40.8591 68.7754 41.0875 68.9624 41.3481 69.0936C41.6087 69.2247 41.8951 69.2968 42.1868 69.3046C42.6141 69.3046 42.9583 69.4706 43.3738 69.518C43.4733 69.5553 43.5829 69.5553 43.6824 69.518L46.2939 68.5578Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 14,
    width: 6,
    height: 7
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5901 14.0956H38.4952H38.4239C37.9729 14.1668 37.5099 14.2023 37.1182 14.2616C36.9299 14.3647 36.7099 14.3943 36.501 14.3446C36.4699 14.328 36.4353 14.3193 36.4001 14.3193C36.3649 14.3193 36.3302 14.328 36.2992 14.3446C36.0032 14.7512 35.7968 15.2159 35.6938 15.7079C35.6938 15.7079 35.6938 15.8976 35.765 15.8383C35.8362 15.7791 35.8718 16.028 35.9668 16.0636H36.3467C36.406 16.0636 36.5366 16.0636 36.5247 16.1466C36.4981 16.2989 36.4327 16.4417 36.3348 16.5615C36.2283 16.7131 36.1589 16.8875 36.1321 17.0707C36.1053 17.254 36.1219 17.4409 36.1805 17.6166C36.2575 17.8312 36.2575 18.0659 36.1805 18.2805C36.1485 18.3554 36.132 18.4361 36.132 18.5176C36.132 18.5991 36.1485 18.6797 36.1805 18.7547C36.2852 18.9489 36.4042 19.1352 36.5366 19.3119C36.6702 19.6231 36.8987 19.8844 37.1894 20.0587L38.8038 20.5685C38.8476 20.5734 38.8919 20.566 38.9317 20.5471C38.9716 20.5283 39.0054 20.4987 39.0293 20.4618C39.1626 20.213 39.3092 19.9716 39.4685 19.7386C39.7705 19.2106 40.0209 18.6548 40.2163 18.0789C40.2551 17.9762 40.3028 17.877 40.3588 17.7826C40.4333 17.6794 40.4819 17.5598 40.5005 17.434C40.519 17.3081 40.5071 17.1797 40.4656 17.0594C40.4477 16.94 40.4117 16.8241 40.3588 16.7156C40.1333 16.5615 39.8246 16.4429 39.6822 16.194C39.7345 15.9457 39.831 15.7088 39.9671 15.4945C39.5272 15.2929 39.1796 14.9331 38.9937 14.4869C38.9885 14.469 38.9796 14.4525 38.9675 14.4384C38.9554 14.4243 38.9404 14.4129 38.9235 14.405C38.9067 14.3972 38.8883 14.393 38.8697 14.3928C38.8511 14.3926 38.8327 14.3964 38.8157 14.4039C38.7088 14.309 38.8157 14.1786 38.8157 14.0482C38.7421 14.0703 38.6637 14.0703 38.5901 14.0482",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6318 14.0482H35.6463V20.7108H40.6318V14.0482Z",
    fill: "url(#paint119_radial_187_41690)"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2638 18.2093C40.2788 18.0639 40.3106 17.9207 40.3588 17.7826C40.4324 17.6789 40.4804 17.5594 40.499 17.4338C40.5175 17.3081 40.5061 17.1798 40.4656 17.0594C40.4526 16.939 40.4163 16.8222 40.3588 16.7156C40.1451 16.5615 39.8365 16.4429 39.694 16.194C39.7464 15.9457 39.8428 15.7088 39.9789 15.4945C39.5391 15.2929 39.1915 14.9331 39.0056 14.4869C39.0004 14.469 38.9914 14.4525 38.9793 14.4384C38.9672 14.4243 38.9522 14.4129 38.9354 14.405C38.9185 14.3972 38.9002 14.393 38.8816 14.3928C38.863 14.3926 38.8445 14.3964 38.8275 14.4039C38.7207 14.309 38.8275 14.1786 38.8275 14.0482C38.7207 14.1193 38.602 14.0482 38.507 14.0482C38.412 14.0482 38.4358 14.0482 38.4358 14.0482C37.9847 14.1193 37.5218 14.1549 37.1301 14.2142C36.9373 14.317 36.7138 14.3465 36.5009 14.2972C36.4717 14.2816 36.4391 14.2735 36.406 14.2735C36.3728 14.2735 36.3402 14.2816 36.311 14.2972C36.015 14.7038 35.8087 15.1684 35.7056 15.6605C35.7056 15.6605 35.7056 15.8502 35.7768 15.7909C35.8481 15.7316 35.8837 15.9806 35.9786 16.0043C36.0736 16.028 36.2873 16.0043 36.3585 16.0043C36.4297 16.0043 36.5484 16.0043 36.5365 16.0873C36.5099 16.2396 36.4445 16.3825 36.3466 16.5022C36.2402 16.6538 36.1708 16.8282 36.144 17.0115C36.1172 17.1947 36.1337 17.3816 36.1923 17.5573C36.2693 17.7719 36.2693 18.0066 36.1923 18.2212C36.1603 18.2962 36.1438 18.3768 36.1438 18.4583C36.1438 18.5398 36.1603 18.6204 36.1923 18.6954C36.297 18.8897 36.4161 19.0759 36.5484 19.2526C36.6785 19.5661 36.9078 19.8284 37.2013 19.9995L38.8156 20.5092C38.8594 20.5141 38.9037 20.5067 38.9436 20.4879C38.9834 20.469 39.0172 20.4395 39.0412 20.4025C39.1744 20.1538 39.3211 19.9124 39.4804 19.6794C39.7842 19.2132 40.0463 18.7213 40.2638 18.2093Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 36,
    width: 6,
    height: 2
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2512 36.2409H28.1562C27.8544 36.3974 27.6155 36.6527 27.4796 36.964C27.531 37.0906 27.623 37.1964 27.7412 37.2651C27.8593 37.3338 27.997 37.3613 28.1325 37.3434L30.2454 37.047C30.7677 37.13 31.195 37.296 31.6817 37.4145C31.7833 37.4371 31.8887 37.4371 31.9903 37.4145C32.0853 37.4145 32.1921 37.3197 32.1802 37.2249C32.162 37.105 32.1188 36.9903 32.0534 36.8882C31.9879 36.7861 31.9017 36.6988 31.8004 36.6321C31.3849 36.5017 30.8745 36.4424 30.4353 36.2883H29.1414C28.9385 36.2427 28.732 36.2149 28.5242 36.2053H28.2512",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1921 36.2053H27.4796V37.4738H32.1921V36.2053Z",
    fill: "url(#paint120_radial_187_41690)"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1414 36.2883C28.849 36.2169 28.5436 36.2169 28.2512 36.2883H28.1562C27.8519 36.4415 27.6121 36.6978 27.4796 37.0114C27.531 37.1379 27.623 37.2438 27.7412 37.3125C27.8593 37.3811 27.997 37.4087 28.1325 37.3908L30.2454 37.0944C30.7677 37.1774 31.195 37.3434 31.6817 37.4619C31.7833 37.4844 31.8887 37.4844 31.9903 37.4619C32.0853 37.4619 32.1921 37.3671 32.1802 37.2722C32.1635 37.1519 32.1209 37.0366 32.0553 36.9343C31.9897 36.832 31.9028 36.7451 31.8004 36.6795C31.3849 36.5491 30.8745 36.4898 30.4353 36.3357L29.1414 36.2883Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 19,
    width: 3,
    height: 2
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1541 19.2526C40.9475 19.3994 40.7804 19.5949 40.6674 19.8216C40.8399 20.0013 41.057 20.1322 41.2965 20.201H41.8544C42.0222 20.1277 42.1814 20.0363 42.3293 19.9283C42.448 19.8216 42.3293 19.6556 42.2462 19.5964C41.9668 19.4215 41.6627 19.2896 41.344 19.2051C41.2852 19.1945 41.2248 19.1945 41.166 19.2051",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.448 19.205H40.6674V20.1889H42.448V19.205Z",
    fill: "url(#paint121_radial_187_41690)"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1541 19.2526C41.217 19.243 41.2811 19.243 41.344 19.2526C41.6603 19.3383 41.9637 19.4659 42.2462 19.6319C42.353 19.7031 42.448 19.869 42.3293 19.9757C42.1814 20.0837 42.0222 20.1751 41.8544 20.2484H41.2965C41.057 20.1796 40.8399 20.0487 40.6674 19.869C40.7736 19.625 40.9413 19.4126 41.1541 19.2526Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 26,
    width: 23,
    height: 30
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M54.793 28.1083C54.793 28.1083 54.1401 29.0923 53.4873 29.1753C52.8344 29.2582 52.1815 29.1753 51.8967 29.3057C51.6546 29.8433 51.5215 30.4235 51.5049 31.0128C51.1612 31.5559 50.9762 32.1841 50.9708 32.8266C50.8639 33.5261 50.769 34.2492 50.6622 34.9131C50.6081 35.5125 50.6081 36.1156 50.6622 36.7151C50.6631 37.0344 50.7597 37.3462 50.9395 37.6103C51.1193 37.8743 51.3741 38.0787 51.6711 38.1969L52.0747 38.6119C52.2884 38.9082 52.4189 39.2876 52.6326 39.584C52.7963 39.9009 53.0337 40.174 53.3249 40.3802C53.6162 40.5865 53.9527 40.72 54.3063 40.7695C54.9059 40.8108 55.5076 40.7302 56.075 40.5324C56.6258 40.5366 57.1688 40.402 57.6537 40.1412C58.2592 39.8521 58.9094 39.6677 59.5767 39.5958C59.6945 39.6122 59.8076 39.6525 59.9091 39.7144C60.4551 39.9752 60.6094 40.6509 60.7875 41.2793C60.8243 41.8112 61.0519 42.312 61.4285 42.69C61.6833 43.465 61.8817 44.2574 62.022 45.061C62.1288 45.5352 62.3306 46.2465 62.022 46.6614C61.9311 46.7688 61.8631 46.8936 61.8223 47.0282C61.7815 47.1627 61.7686 47.3042 61.7846 47.4439L62.5917 49.3763C62.5715 49.842 62.4794 50.3019 62.3187 50.7396C62.3285 51.6139 62.4079 52.486 62.5561 53.3477C62.475 53.8616 62.356 54.3688 62.2 54.8651C62.1715 54.9478 62.1724 55.0379 62.2027 55.12C62.233 55.2021 62.2907 55.2712 62.3662 55.3156C63.4227 55.2445 64.4079 55.0904 65.5118 55.0192C65.7298 55.0176 65.9418 54.947 66.1172 54.8177C66.3232 54.2315 66.6992 53.7198 67.1974 53.3477C67.2929 52.9115 67.4924 52.5048 67.779 52.1622C68.0402 51.8777 68.3963 51.688 68.6693 51.4035C68.8592 50.7751 68.9067 50.0283 69.1441 49.4829C69.9144 48.4948 70.7682 47.5747 71.6962 46.7326C72.0929 44.4952 72.2007 42.2162 72.0167 39.9515C71.8887 38.5854 71.6826 37.2278 71.3994 35.8852C70.8945 34.0331 70.2923 32.2088 69.5952 30.42C68.9779 29.1041 68.0995 27.6341 68.0995 27.6341L67.6959 27.7171C67.6959 27.7171 67.8977 28.3573 67.2805 28.2268C66.6632 28.0964 65.2032 27.3733 65.1201 27.7526C65.0756 28.1166 65.1162 28.4859 65.2388 28.8315C65.3219 29.0804 65.9035 29.7206 65.3219 29.5902C64.7402 29.4598 63.9806 29.3412 63.9806 29.3412C63.821 29.124 63.6116 28.9482 63.37 28.8285C63.1283 28.7089 62.8614 28.6489 62.5917 28.6536C61.6896 28.6536 60.9536 28.5706 60.8349 28.0964C60.7162 27.6222 60.1821 26.9109 57.9742 26.7805H57.7012C57.1493 26.7559 56.5992 26.8598 56.0945 27.0841C55.5897 27.3083 55.1442 27.6468 54.793 28.0727",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1829 26.816H50.5672V55.2919H72.1829V26.816Z",
    fill: "url(#paint122_radial_187_41690)"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0167 39.999C71.8887 38.6329 71.6826 37.2753 71.3994 35.9327C70.8945 34.0806 70.2923 32.2563 69.5952 30.4675C68.9779 29.1398 68.0995 27.6816 68.0995 27.6816L67.6959 27.7646C67.6959 27.7646 67.8977 28.4047 67.2805 28.2743C66.6632 28.1439 65.2032 27.4208 65.1201 27.8001C65.0744 28.1602 65.1151 28.5259 65.2388 28.8671C65.3219 29.1279 65.8917 29.7681 65.3219 29.6377C64.7521 29.5073 63.9806 29.3887 63.9806 29.3887C63.8232 29.1693 63.6142 28.9918 63.372 28.8719C63.1299 28.752 62.8619 28.6934 62.5917 28.7011C61.6896 28.7011 60.9536 28.6181 60.8349 28.1439C60.7162 27.6697 60.1821 26.9584 57.9742 26.828C57.3794 26.7632 56.7777 26.8462 56.2228 27.0696C55.6678 27.2929 55.1766 27.6498 54.793 28.1084C54.793 28.1084 54.1401 29.0923 53.4873 29.1753C52.8344 29.2583 52.1815 29.1753 51.8967 29.3057C51.6534 29.843 51.5202 30.4234 51.5049 31.0129C51.1612 31.556 50.9762 32.1842 50.9708 32.8267C50.8639 33.5261 50.769 34.2493 50.6622 34.9132C50.6081 35.5126 50.6081 36.1157 50.6622 36.7151C50.6631 37.0345 50.7597 37.3463 50.9395 37.6103C51.1193 37.8744 51.3741 38.0787 51.6711 38.197L52.0747 38.6119C52.2884 38.9083 52.4189 39.2877 52.6326 39.5841C52.7963 39.901 53.0337 40.174 53.3249 40.3803C53.6162 40.5866 53.9527 40.7201 54.3063 40.7696C54.9058 40.8102 55.5074 40.7296 56.075 40.5325C56.6258 40.5367 57.1688 40.4021 57.6537 40.1412C58.2592 39.8522 58.9094 39.6678 59.5767 39.5959C59.6945 39.6122 59.8076 39.6526 59.9091 39.7145C60.4551 39.9753 60.6094 40.651 60.7875 41.2793C60.8243 41.8113 61.0519 42.3121 61.4285 42.6901C61.6833 43.4651 61.8817 44.2575 62.022 45.0611C62.1288 45.5353 62.3306 46.2466 62.022 46.6615C61.9285 46.7673 61.859 46.8919 61.818 47.0269C61.7771 47.1619 61.7657 47.3042 61.7846 47.4439L62.5917 49.3763C62.5739 49.8435 62.4776 50.3043 62.3068 50.7396C62.3264 51.6139 62.4097 52.4856 62.5561 53.3478C62.475 53.8616 62.356 54.3688 62.2 54.8652C62.1715 54.9479 62.1724 55.0379 62.2027 55.12C62.233 55.2021 62.2907 55.2713 62.3662 55.3157C63.4227 55.2446 64.4079 55.0904 65.5118 55.0193C65.7296 55.0161 65.941 54.9457 66.1172 54.8178C66.3232 54.2316 66.6992 53.7198 67.1974 53.3478C67.2929 52.9116 67.4924 52.5049 67.779 52.1623C68.0402 51.8777 68.3963 51.6881 68.6693 51.4035C68.8592 50.7752 68.9067 50.0283 69.1441 49.483C69.9147 48.4916 70.7685 47.5675 71.6962 46.7208C72.0892 44.503 72.1969 42.2441 72.0167 39.999Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_187_41690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 13,
    width: 22,
    height: 17
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0446 13.657C46.0446 13.7518 46.0446 13.8348 46.0446 13.8585C46.0966 14.3251 46.0185 14.7968 45.8191 15.2219C45.7965 15.2871 45.7965 15.3581 45.8191 15.4234C45.9378 15.6249 46.0684 15.8146 46.1989 16.0043C46.5906 16.2295 47.0061 16.4311 47.2435 16.5378C47.7658 16.7867 48.3712 16.0991 48.3712 16.0991L49.4276 16.5022L49.9499 16.7037L50.7096 17.0238L50.9945 16.8223L50.4722 16.3837L49.2852 15.3641L48.478 15.2456L47.7064 14.724L47.1011 14.4039H47.5521L48.5967 14.9373L50.2111 15.4945L51.0182 15.5775L51.5049 15.9806H52.0747L51.8254 16.3007L52.7513 17.1068L52.229 17.3439C52.229 17.3439 51.5049 17.1068 51.5405 17.3439C51.5761 17.581 50.3535 17.5455 50.3535 17.5455L49.9974 17.2609L49.855 16.9883L49.2615 16.8223L48.8579 16.9883L50.0449 18.1145L49.5938 18.6835L49.7244 19.3237L49.5226 19.9283L49.1902 20.4144L48.8341 20.9004C48.6766 20.8839 48.5173 20.9042 48.369 20.9598C48.2206 21.0153 48.0873 21.1046 47.9795 21.2205C47.5759 21.6236 48.1813 21.6236 49.1665 21.9081C50.1517 22.1926 51.2675 23.9235 51.2675 23.9235C50.8774 24.0198 50.4806 24.0871 50.0805 24.125C49.5275 24.1369 48.9761 24.1884 48.4305 24.2791L47.5996 24.8837C47.4453 24.8837 48.1219 25.6662 48.3356 25.9388C48.4993 26.1802 48.5862 26.4653 48.5848 26.7568C48.6442 27.1955 48.6442 27.4918 48.6679 27.5274C48.9291 27.8949 49.4989 27.646 49.4751 28.0135C49.4514 28.381 49.8194 28.5232 49.9143 28.6892C50.0093 28.8552 50.1755 28.6892 50.3773 28.6892C50.4798 28.6779 50.5833 28.6779 50.6859 28.6892L51.7898 29.0567C51.8703 28.8465 52.0091 28.6635 52.1898 28.5292C52.3706 28.3948 52.5859 28.3146 52.8107 28.298C53.3804 28.298 53.4279 27.9542 53.4279 27.9542L53.5466 27.0532L53.416 26.1404L53.1311 25.2038L53.3329 24.4332L53.8315 23.876C53.8315 23.876 53.2142 23.1055 53.9146 22.8091C54.6149 22.5127 55.339 22.5127 55.339 22.2519C55.339 21.9911 56.1106 22.5957 56.3598 22.6787C56.9398 23.016 57.5746 23.2487 58.2353 23.3663C58.8921 23.4777 59.5186 23.724 60.0752 24.0894L60.8468 24.943L60.4788 24.0065L60.7281 23.876C60.4964 23.627 60.2181 23.4257 59.909 23.2833C59.4224 23.0699 58.1523 22.6313 58.1523 22.6313L56.8109 21.8725L56.1937 21.2679C56.8514 21.504 57.521 21.7058 58.1997 21.8725C58.9581 22.2169 59.6919 22.613 60.3957 23.0581L61.381 23.7812L62.0694 24.5162C62.3641 24.7796 62.6775 25.0213 63.0072 25.2394C63.1734 25.2394 63.8737 25.5358 63.8737 25.3698C63.8057 25.1021 63.7061 24.8434 63.577 24.5992L62.8529 23.9116L62.568 23.141L62.8529 23.3189L63.4582 24.042L64.2298 24.6348L64.8115 24.8126L65.1794 25.2394L65.5474 24.7652H66.0341L66.6039 25.7847L66.8056 25.5832C65.74 24.0872 64.5097 22.7153 63.1377 21.4932C62.9834 21.3628 62.8529 21.1257 62.6273 21.0664L60.4432 19.1696C60.1624 18.9083 59.8607 18.6704 59.5411 18.4583C55.601 15.7488 51.0492 14.0583 46.2939 13.5385C46.2561 13.5396 46.2193 13.5513 46.1878 13.5722C46.1564 13.5932 46.1314 13.6226 46.1158 13.657",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_187_41690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7938 13.5385H45.8309V29.0211H66.7938V13.5385Z",
    fill: "url(#paint123_radial_187_41690)"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4306 16.0992L49.487 16.5023L50.0093 16.7038L50.769 17.0239L51.0539 16.8224L50.5316 16.3837L49.3446 15.3642L48.5374 15.2456L47.7658 14.724L47.1605 14.4039H47.6115L48.6561 14.9374L50.2705 15.4946L51.0776 15.5776L51.5643 15.9807H52.1341L51.8848 16.3007L52.8107 17.1069L52.2884 17.344C52.2884 17.344 51.5643 17.1069 51.5999 17.344C51.6355 17.5811 50.4129 17.5455 50.4129 17.5455L50.0568 17.261L49.9381 16.9883L49.3327 16.8224L48.9291 16.9883L50.1161 18.1146L49.6651 18.6836L49.7956 19.3238L49.5938 19.9284L49.2615 20.4144L48.9054 20.9005C48.7478 20.884 48.5886 20.9043 48.4402 20.9598C48.2919 21.0154 48.1585 21.1047 48.0507 21.2206C47.6471 21.6237 48.2525 21.6237 49.2377 21.9082C50.223 22.1927 51.3388 23.9235 51.3388 23.9235C50.9486 24.0198 50.5519 24.0872 50.1518 24.1251C49.5988 24.137 49.0474 24.1885 48.5018 24.2792L47.6709 24.8838C47.5166 24.8838 48.1932 25.6662 48.4068 25.9389C48.5706 26.1802 48.6575 26.4654 48.6561 26.7569C48.7155 27.1955 48.7155 27.4919 48.7392 27.5275C49.0003 27.8831 49.5701 27.646 49.5464 28.0135C49.5226 28.381 49.8906 28.5233 49.9856 28.6893C50.0805 28.8552 50.7215 28.63 50.7571 28.6893L51.8611 29.0568C51.9477 28.8496 52.0879 28.6691 52.2672 28.5337C52.4466 28.3983 52.6587 28.3129 52.8819 28.2862C53.4517 28.2862 53.4992 27.9542 53.4992 27.9542L53.6179 27.0533L53.4161 26.1404L53.1312 25.2039L53.333 24.4333L53.8315 23.8761C53.8315 23.8761 53.2143 23.1055 53.9146 22.8092C54.615 22.5128 55.339 22.5128 55.339 22.252C55.339 21.9912 56.1106 22.5958 56.3599 22.6788C56.9398 23.016 57.5747 23.2488 58.2354 23.3663C58.8921 23.4778 59.5186 23.724 60.0753 24.0895L60.8468 24.9431L60.4789 24.0065L60.7281 23.8761C60.4964 23.6271 60.2182 23.4257 59.9091 23.2834C59.4224 23.07 58.1523 22.6313 58.1523 22.6313L56.811 21.8726L56.1937 21.268C56.8515 21.5041 57.521 21.7059 58.1998 21.8726C58.9582 22.2169 59.6919 22.6131 60.3958 23.0581L61.381 23.7813L62.0695 24.5163C62.3641 24.7797 62.6775 25.0214 63.0072 25.2394C63.1734 25.2394 63.8737 25.5358 63.8737 25.3698C63.8089 25.1029 63.7133 24.8443 63.5889 24.5993L62.8529 23.9117L62.568 23.1411L62.8529 23.3189L63.4583 24.0421L64.2417 24.6348L64.8115 24.8127L65.1795 25.2394L65.5474 24.7652H66.0341L66.6039 25.7848L66.8057 25.5832C65.74 24.0872 64.5097 22.7153 63.1378 21.4932C62.9835 21.3628 62.8529 21.1376 62.6274 21.0665L60.4432 19.1697C60.1643 18.9112 59.8667 18.6734 59.553 18.4584C55.6051 15.7554 51.0512 14.0656 46.2939 13.5385C46.2519 13.5342 46.2098 13.545 46.175 13.5689C46.1402 13.5928 46.115 13.6282 46.104 13.6689C46.104 13.7519 46.104 13.8349 46.104 13.8586C46.156 14.3251 46.0779 14.7969 45.8785 15.2219C45.8559 15.2872 45.8559 15.3582 45.8785 15.4235C45.9972 15.625 46.1277 15.8147 46.2583 16.0044C46.65 16.2296 47.0655 16.4311 47.3029 16.5378C47.8252 16.7868 48.4306 16.0992 48.4306 16.0992Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6241 25.026L59.7072 25.4883L60.8587 25.7847L60.9417 25.4528L60.4788 24.9312L59.6241 25.026Z",
    fill: "#90A6CE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4788 24.9312L59.6241 25.026L59.7072 25.4883L60.8587 25.7847L60.9417 25.4528L60.4788 24.9312Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7516 24.6704L57.4757 25.6069L58.0692 25.7847L58.0336 25.2631L57.262 24.457L56.8703 24.4095L56.7516 24.6704Z",
    fill: "#90A6CE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7516 24.6704L57.4757 25.6069L58.0692 25.7847L58.0336 25.2631L57.262 24.457L56.8703 24.4095L56.7516 24.6704Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9444 23.39L56.4667 24.0302H56.7634L56.2886 23.307L55.9444 23.39Z",
    fill: "#90A6CE"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9444 23.39L56.4667 24.0302H56.7634L56.2886 23.307L55.9444 23.39Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M47.564 20.8411L48.4424 20.2721L49.1071 20.0113L48.8816 19.7031L48.7273 19.4778L48.1812 19.3948L47.5165 19.1103L47.0298 18.8495L46.7212 18.8258L46.5906 18.3753H46.1039L45.6885 18.1382L45.4867 18.4227L45.9496 18.7665L46.1039 19.134L46.3057 19.3355L46.6975 19.2526L47.1604 19.3118L47.3622 19.6201L46.9705 19.5608L47.3028 19.869V20.1535L47.6946 20.2958L47.564 20.8411Z",
    fill: "#99ADD2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M47.564 20.8411L48.4424 20.2721L49.1071 20.0113L48.8816 19.7031L48.7273 19.4778L48.1812 19.3948L47.5165 19.1103L47.0298 18.8495L46.7212 18.8258L46.5906 18.3753H46.1039L45.6885 18.1382L45.4867 18.4227L45.9496 18.7665L46.1039 19.134L46.3057 19.3355L46.6975 19.2526L47.1604 19.3118L47.3622 19.6201L46.9705 19.5608L47.3028 19.869V20.1535L47.6946 20.2958L47.564 20.8411Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6885 19.5016V19.7268L45.5342 19.7742L45.6173 19.9995L45.8903 20.1299V20.5804L46.4126 20.6041L46.9823 20.2484L46.8518 19.9402L46.4957 19.6675L46.104 19.4186L45.6885 19.5016Z",
    fill: "#99ADD2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M46.104 19.4186L46.4957 19.6675L46.8518 19.9402L46.9823 20.2484L46.4126 20.6041L45.8903 20.5804V20.1417L45.6173 19.9995L45.5342 19.7742L45.6885 19.7268V19.5016L46.104 19.4186Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3672 37.0707V37.5093L32.382 37.7346L33.1536 37.948H34.3525L35.2309 38.2799L34.6848 37.4026L34.2456 36.8573L33.3672 37.0707Z",
    fill: "#BCC8E1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3672 37.0707V37.5093L32.382 37.7346L33.1536 37.948H34.3525L35.2309 38.2799L34.6848 37.4026L34.2456 36.8573L33.3672 37.0707Z",
    stroke: "#DBE0EE",
    strokeWidth: 0.02
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9417 51.6999C17.6748 51.4983 18.4938 51.2968 18.4938 49.3289V35.6481C16.8676 33.6565 16.4047 33.5735 16.0248 33.5735V32.8385H22.138L32.2039 45.2152H32.2633V36.4306C32.2633 34.6997 31.919 33.7395 29.5687 33.5735V32.8385H35.8006V33.5735C33.7114 33.8343 33.5334 34.4982 33.5334 35.8852V52.9447H32.7262L19.8233 37.2486H19.7639V48.831C19.7639 50.9174 20.3693 51.4628 22.5178 51.6999V52.423H15.9417V51.6999Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9417 51.6999C17.6748 51.4983 18.4938 51.2968 18.4938 49.3289V35.6481C16.8676 33.6565 16.4047 33.5735 16.0248 33.5735V32.8385H22.138L32.2039 45.2152H32.2633V36.4306C32.2633 34.6997 31.919 33.7395 29.5687 33.5735V32.8385H35.8006V33.5735C33.7114 33.8343 33.5334 34.4982 33.5334 35.8852V52.9447H32.7262L19.8233 37.2486H19.7639V48.831C19.7639 50.9174 20.3693 51.4628 22.5178 51.6999V52.423H15.9417V51.6999Z",
    stroke: "#005699",
    strokeWidth: 0.28
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6294 38.6593C49.1071 36.6439 47.3622 33.3126 43.9436 33.3126C43.5562 33.275 43.1652 33.3177 42.7952 33.438C42.4251 33.5584 42.0839 33.7538 41.7931 34.0121C41.5022 34.2703 41.2679 34.5858 41.1048 34.9387C40.9417 35.2916 40.8534 35.6744 40.8454 36.063C40.8454 37.6279 41.3915 38.2562 43.8367 39.4773L48.0982 41.5875C49.0644 42.1032 49.8713 42.8727 50.4319 43.8128C50.9926 44.7529 51.2856 45.828 51.2794 46.9222C51.2794 49.4711 49.4276 52.9683 44.0979 52.9683C41.3321 52.9683 40.0264 51.9843 39.1361 51.9843C38.5189 51.9843 38.3764 52.506 38.2577 52.9683H37.4268V45.8553H38.2577C38.8394 48.7835 40.5249 52.0555 44.1928 52.0555C44.6504 52.1073 45.1137 52.0619 45.5525 51.9222C45.9912 51.7825 46.3953 51.5516 46.7384 51.2449C47.0814 50.9381 47.3556 50.5623 47.5429 50.1421C47.7302 49.722 47.8264 49.2671 47.8251 48.8072C47.8251 46.8629 46.4601 46.1754 44.5727 45.2507L42.626 44.326C37.6642 41.955 37.6642 39.4535 37.6642 38.1258C37.6642 36.3594 38.5664 32.4235 44.086 32.4235C46.4601 32.4235 47.7658 33.3719 48.6086 33.3719C49.4514 33.3719 49.4158 32.9451 49.5582 32.3879H50.4366V38.6711L49.6294 38.6593Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6294 38.6593C49.1071 36.6439 47.3622 33.3126 43.9436 33.3126C43.5562 33.275 43.1652 33.3177 42.7952 33.438C42.4251 33.5584 42.0839 33.7538 41.7931 34.0121C41.5022 34.2703 41.2679 34.5858 41.1048 34.9387C40.9417 35.2916 40.8534 35.6744 40.8454 36.063C40.8454 37.6279 41.3915 38.2562 43.8367 39.4773L48.0982 41.5875C49.0644 42.1032 49.8713 42.8727 50.4319 43.8128C50.9926 44.7529 51.2856 45.828 51.2794 46.9222C51.2794 49.4711 49.4276 52.9683 44.0979 52.9683C41.3321 52.9683 40.0264 51.9843 39.1361 51.9843C38.5189 51.9843 38.3764 52.506 38.2577 52.9683H37.4268V45.8553H38.2577C38.8394 48.7835 40.5249 52.0555 44.1928 52.0555C44.6504 52.1073 45.1137 52.0619 45.5525 51.9222C45.9912 51.7825 46.3953 51.5516 46.7384 51.2449C47.0814 50.9381 47.3556 50.5623 47.5429 50.1421C47.7302 49.722 47.8264 49.2671 47.8251 48.8072C47.8251 46.8629 46.4601 46.1754 44.5727 45.2507L42.626 44.326C37.6642 41.955 37.6642 39.4535 37.6642 38.1258C37.6642 36.3594 38.5664 32.4235 44.086 32.4235C46.4601 32.4235 47.7658 33.3719 48.6086 33.3719C49.4514 33.3719 49.4158 32.9451 49.5582 32.3879H50.4366V38.6711L49.6294 38.6593Z",
    stroke: "#005699",
    strokeWidth: 0.28
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9887 32.8385H69.429V38.6593H68.7405C68.0995 35.6481 67.3161 33.8343 62.3306 33.8343C60.7637 33.8343 60.2414 33.941 60.2414 35.1858V41.9076C63.8025 41.9076 64.2654 39.916 64.6809 37.5924H65.405V47.4202H64.6809C64.3604 45.0492 63.8975 42.9271 60.2414 42.9271V49.6727C60.2414 51.5932 61.4284 51.6525 63.4345 51.7354V52.4586H52.9887V51.7354C54.6387 51.5576 55.5408 51.4746 55.5408 49.6727V35.6244C55.5408 33.7158 54.3538 33.6565 52.9887 33.5617V32.8385Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9887 32.8385H69.429V38.6593H68.7405C68.0995 35.6481 67.3161 33.8343 62.3306 33.8343C60.7637 33.8343 60.2414 33.941 60.2414 35.1858V41.9076C63.8025 41.9076 64.2654 39.916 64.6809 37.5924H65.405V47.4202H64.6809C64.3604 45.0492 63.8975 42.9271 60.2414 42.9271V49.6727C60.2414 51.5932 61.4284 51.6525 63.4345 51.7354V52.4586H52.9887V51.7354C54.6387 51.5576 55.5408 51.4746 55.5408 49.6727V35.6244C55.5408 33.7158 54.3538 33.6565 52.9887 33.5617V32.8385Z",
    stroke: "#005699",
    strokeWidth: 0.28
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7328 13.0405C48.6021 13.0405 54.3396 14.7787 59.2197 18.0354C64.0998 21.292 67.9034 25.9208 70.1495 31.3363C72.3956 36.7519 72.9832 42.711 71.8382 48.4601C70.6932 54.2093 67.8668 59.4902 63.7166 63.6351C59.5664 67.78 54.2787 70.6027 48.5222 71.7463C42.7658 72.8898 36.799 72.3029 31.3765 70.0597C25.954 67.8165 21.3193 64.0178 18.0585 59.1439C14.7977 54.27 13.0573 48.5399 13.0573 42.6781C13.0573 34.8178 16.1838 27.2793 21.749 21.7212C27.3143 16.1631 34.8624 13.0405 42.7328 13.0405ZM42.7328 13.408C35.4674 13.3742 28.4484 16.0368 23.0375 20.8793C17.6266 25.7218 14.2096 32.3989 13.4495 39.6153C12.6893 46.8317 14.6401 54.0728 18.9234 59.9339C23.2068 65.795 29.5173 69.8582 36.6307 71.3352C43.7441 72.8121 51.1532 71.5976 57.4207 67.9273C63.6882 64.2569 68.3672 58.3923 70.5499 51.4713C72.7327 44.5503 72.2636 37.0663 69.2336 30.4712C66.2037 23.8761 60.8289 18.6401 54.152 15.779C50.5446 14.228 46.6603 13.4215 42.7328 13.408Z",
    fill: "#AD8400"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0008 20.5476) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.833 5.88298) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6684 20.3462) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3107 5.56294) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.37638 -1.84759) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2009 6.1082) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.71162 -2.23881) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9992 5.97781) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.10047 -0.554303) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2574 6.73655) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5811 8.7519) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5334 6.29801) scale(85.5724 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6761 8.82313) scale(85.5724 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4687 12.3321) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8422 8.91788) scale(85.5724 85.4628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8544 11.36) scale(85.5724 85.4628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1395 13.9562) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9702 12.0357) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4957 14.1696) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.5069 -1.76463) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7863 13.1382) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.04401 -2.04918) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7003 13.6954) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.17457 -1.96621) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7003 13.6954) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7945 6.4638) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9755 5.96534) scale(85.5723 85.4639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9754 5.96587) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0348 6.00144) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.71167 -2.2386) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.833 5.88315) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.22497 -2.54702) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6787 5.78814) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8093 5.85925) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7589 6.44015) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4413 5.64585) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5571 6.32159) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.762 8.25398) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5571 6.32161) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.394 8.04022) scale(85.5726 85.4636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.738 5.82331) scale(85.5726 85.4636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6141 11.8105) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.738 5.82353) scale(85.5724 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7951 11.3122) scale(85.5726 85.4635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5126 5.68105) scale(85.5726 85.4635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2138 13.3871) scale(85.5725 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6432 5.7643) scale(85.5725 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2346 14.0153) scale(85.5725 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7738 5.84719) scale(85.5725 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.48606 -2.38117) scale(85.5726 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0704 6.02513) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.026 7.81531) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4001 9.26163) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1572 12.7589) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.833 5.88295) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.5069 -1.76453) scale(85.5726 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9587 14.4542) scale(85.5723 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.14222 0.690374) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1506 6.67724) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5394 7.51899) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4452 14.7505) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9755 5.96604) scale(85.5722 85.4628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.773 5.84733) scale(85.5735 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7381 5.82371) scale(85.5721 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.557 6.32152) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8007 7.68485) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7381 5.82361) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5038 7.50708) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1089 5.4443) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3407 9.21415) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1059 6.04886) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7681 9.475) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.106 6.04889) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1155 11.5141) scale(85.5726 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1653 6.08447) scale(85.5726 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2669 12.2135) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8301 6.48752) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3408 9.21412) scale(85.5723 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1126 12.1186) scale(85.5723 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2366 6.11994) scale(85.5723 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4073 20.192) scale(85.5726 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.83 6.48755) scale(85.5726 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.30585 -5.17342) scale(85.5842 85.4748)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4977 6.28613) scale(85.5724 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4767 5.65766) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.462 6.26227) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9282 20.4985) scale(85.5663 85.4682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4417 5.64326) scale(85.5663 85.4682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8096 5.85667) scale(85.5663 85.4682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.71187 -2.23875) scale(85.5722 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6641 6.38093) scale(85.5722 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9022 13.814) scale(85.5722 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5127 5.6814) scale(85.5722 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9227 14.4304) scale(85.5727 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 6.04894) scale(85.5727 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.73873 0.441459) scale(85.5723 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2367 6.12003) scale(85.5723 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.77424 0.465151) scale(85.5724 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5719 5.72883) scale(85.5724 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9963 6.58243) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3819 5.59847) scale(85.5725 85.463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8509 7.10405) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0495 5.40878) scale(85.5725 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9082 15.035) scale(85.5722 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5719 5.72882) scale(85.5722 85.4629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3501 14.6912) scale(85.573 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0701 6.02518) scale(85.573 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9438 15.0588) scale(85.5723 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5719 5.72884) scale(85.5723 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5775 6.93803) scale(85.5734 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9791 15.0706) scale(85.5734 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.607 5.74067) scale(85.5734 85.4633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3178 16.4933) scale(85.5724 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8539 6.49946) scale(85.5724 85.4632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4067 15.3314) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3CB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4056 5.62211) scale(85.5725 85.4631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2557 31.073) scale(41.2728 41.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FB3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0781BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005699"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.067 41.3723) scale(45.7835 45.7249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9396 43.1031) scale(45.7835 45.7249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9926 39.4992) scale(45.7835 45.7249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.588 19.0805) scale(45.7954 45.7367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1053 38.3491) scale(45.7835 45.7249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5785 27.9612) scale(45.3918 45.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_187_41690",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0285 41.9532) scale(45.7835 45.7249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C4CEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9AAED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#809AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7693C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsf);
export default __webpack_public_path__ + "static/media/nsf.58bf0e2313b3e7bdb5727c1167a2e766.svg";
export { ForwardRef as ReactComponent };